"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartialMasterDataDatabaseSchema = exports.PartialMasterDataSchema = exports.MasterDataSchema = exports.MasterDataSchemaWithScore = exports.MasterDataDatabaseSchemaWithScore = exports.MasterDataFields = exports.masterDataDBKeys = exports.masterDataKeys = exports.effectDataFields = exports.DateTimeUtcFromString = void 0;
const effect_1 = require("effect");
const schemas_1 = require("../schemas");
exports.DateTimeUtcFromString = effect_1.Schema.String.annotate({
    description: 'a string to be decoded into a DateTime.Utc',
})
    .pipe(effect_1.Schema.decodeTo(effect_1.Schema.DateTimeUtc, effect_1.SchemaTransformation.dateTimeUtcFromString))
    .annotate({ identifier: 'DateTimeUtcFromString' });
exports.effectDataFields = [
    {
        title: 'Country code',
        key: 'iso3166',
        description: 'ISO 3166 country code',
        type: 'string',
        section: 'Company Information',
        nullable: false,
        schema: effect_1.Schema.String,
        databaseKey: 'iso_3166',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.String,
    },
    {
        title: 'Organization Number',
        key: 'orgnr',
        description: 'The organization number is a unique identifier for businesses. In Bloodline, it is composed of the ISO 3166 country code and the organization number itself.',
        type: 'string',
        section: 'Company Information',
        nullable: false,
        schema: effect_1.Schema.String,
        databaseKey: 'orgnr',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.String,
    },
    {
        title: 'Company Master System Period',
        key: 'companyMasterSysPeriod',
        description: 'The period of the company master system.',
        type: 'string',
        section: 'Company Information',
        nullable: false,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'company_master_sys_period',
        databaseType: 'tstzrange',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Likelihood to Move Score',
        key: 'likelihoodToMoveScore',
        description: 'The likelihood to move score is a numeric value that indicates the probability of a company moving its operations.',
        type: 'number',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'likelihood_to_move_score',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Legal Entity Type',
        key: 'legalEntityType',
        description: 'The legal entity type of the company.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'legal_entity_type',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Address',
        key: 'address',
        description: 'The address of the company.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'address',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Zipcode',
        key: 'zipcode',
        description: 'The zipcode of the company.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'zipcode',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'City',
        key: 'city',
        description: 'The city where the company is located.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'city',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Municipality',
        key: 'muncipality',
        description: 'The municipality where the company is located.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'muncipality',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'County',
        key: 'county',
        description: 'The county where the company is located.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'county',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Region',
        key: 'region',
        description: 'The region where the company is located.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'region',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Website',
        key: 'website',
        description: 'The website of the company.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'website',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Phone',
        key: 'phone',
        description: 'The phone number of the company.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'phone',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Email',
        key: 'email',
        description: 'The email address of the company.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'email',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Registration Date',
        key: 'registrationDate',
        description: 'The registration date of the company.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(exports.DateTimeUtcFromString, { onNoneEncoding: null }),
        databaseKey: 'registration_date',
        databaseType: 'date',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.DateTimeUtcFromDate, { onNoneEncoding: null }),
    },
    {
        title: 'Company Category',
        key: 'companyCategory',
        description: 'The category of the company.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'company_category',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Company Structure',
        key: 'companyStructure',
        description: 'The structure of the company.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'company_structure',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Legal Form',
        key: 'legalForm',
        description: 'The legal form of the company.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'legal_form',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Listing Type',
        key: 'listingType',
        description: 'The type of listing for the company.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'listing_type',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Description (English)',
        key: 'descriptionEn',
        description: 'The English description of the company.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'description_en',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Operational Status',
        key: 'operationalStatus',
        description: 'The operational status of the company.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'operational_status',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Owners',
        key: 'owners',
        description: 'Information about the company owners.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'owners',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Key Persons',
        key: 'keyPersons',
        description: 'Key individuals in the company.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'key_persons',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Signatory',
        key: 'signatory',
        description: 'Authorized signatories for the company.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'signatory',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Parent Company Name',
        key: 'parentCompanyName',
        description: 'Name of the parent company.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'parent_company_name',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Previous Names',
        key: 'previousNames',
        description: 'Previous names the company has operated under.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'previous_names',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Accountant Firm',
        key: 'accountantFirm',
        description: 'The accounting firm used by the company.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'accountant_firm',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Has Private Equity Owner',
        key: 'hasPrivateEquityOwner',
        description: 'Indicates whether the company has a private equity owner.',
        type: 'boolean',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'has_private_equity_owner',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Private Equity Owner',
        key: 'privateEquityOwner',
        description: 'Name of the private equity owner, if applicable.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'private_equity_owner',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Last Fiscal Year',
        key: 'lfy',
        description: 'The last fiscal year for which financial data is available.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(exports.DateTimeUtcFromString, { onNoneEncoding: null }),
        databaseKey: 'lfy',
        databaseType: 'date',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.DateTimeUtcFromDate, { onNoneEncoding: null }),
    },
    {
        title: 'Last Reported Quarter',
        key: 'lrq',
        description: 'The last reported quarter for which financial data is available.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(exports.DateTimeUtcFromString, { onNoneEncoding: null }),
        databaseKey: 'lrq',
        databaseType: 'date',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.DateTimeUtcFromDate, { onNoneEncoding: null }),
    },
    {
        title: 'CEO',
        key: 'ceo',
        description: 'The Chief Executive Officer of the company.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'ceo',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'CEO Birth Year',
        key: 'ceoBirthYear',
        description: 'The birth year of the company CEO.',
        type: 'number',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'ceo_birth_year',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Chairman',
        key: 'chairman',
        description: 'The Chairman of the company board.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'chairman',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Chairman Birth Year',
        key: 'chairmanBirthYear',
        description: 'The birth year of the company chairman.',
        type: 'number',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'chairman_birth_year',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Has Share Issues',
        key: 'hasShareIssues',
        description: 'Indicates whether the company has active share issues.',
        type: 'boolean',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'has_share_issues',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Number of Owners',
        key: 'numberOfOwners',
        description: 'The total number of owners of the company.',
        type: 'number',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'number_of_owners',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Number of Shares',
        key: 'numberOfShares',
        description: 'The total number of shares the company has issued.',
        type: 'number',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'number_of_shares',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Has Foreign Ultimate Parent',
        key: 'hasForeignUltimateParent',
        description: 'Indicates whether the company has an ultimate parent company in a foreign country.',
        type: 'boolean',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'has_foreign_ultimate_parent',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Ultimate Parent Company',
        key: 'ultimateParentCompany',
        description: 'The name of the ultimate parent company.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'ultimate_parent_company',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Ultimate Parent Organization Number',
        key: 'ultimateParentOrgNo',
        description: 'The organization number of the ultimate parent company.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'ultimate_parent_org_no',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Ultimate Parent Net Sales',
        key: 'ultimateParentNetSales',
        description: 'The net sales of the ultimate parent company.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'ultimate_parent_net_sales',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Company Name',
        key: 'companyName',
        description: 'The legal name of the company.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'company_name',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'SNI Classification',
        key: 'sniClassification',
        description: 'The Swedish Standard Industrial Classification of the company.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'sni_classification',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'SNI Classification Code',
        key: 'sniClassificationCode',
        description: 'The code for the Swedish Standard Industrial Classification of the company.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'sni_classification_code',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Financials Updated Date',
        key: 'financialsUpdatedDate',
        description: 'The date when financial information was last updated.',
        type: 'string',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(exports.DateTimeUtcFromString, { onNoneEncoding: null }),
        databaseKey: 'financials_updated_date',
        databaseType: 'date',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.DateTimeUtcFromDate, { onNoneEncoding: null }),
    },
    {
        title: 'Last Updated',
        key: 'lastUpdated',
        description: 'The date when company information was last updated.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(exports.DateTimeUtcFromString, { onNoneEncoding: null }),
        databaseKey: 'last_updated',
        databaseType: 'date',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.DateTimeUtcFromDate, { onNoneEncoding: null }),
    },
    {
        title: 'Company Keywords',
        key: 'companyKeywords',
        description: 'Keywords associated with the company.',
        type: 'array',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
        databaseKey: 'company_keywords',
        databaseType: 'string-array',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
    },
    {
        title: 'Fiscal Year',
        key: 'fiscalYear',
        description: 'The fiscal year for financial reporting.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'fiscal_year',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Currency',
        key: 'currency',
        description: 'The currency used for financial reporting.',
        type: 'string',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'currency',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Net Sales',
        key: 'netSales',
        description: 'The net sales or revenue of the company.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'net_sales',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Cost of Sales',
        key: 'costOfSales',
        description: 'The cost of goods sold or services provided.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'cost_of_sales',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Gross Profit',
        key: 'grossProfit',
        description: 'The gross profit (net sales minus cost of sales).',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'gross_profit',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Administrative Expenses',
        key: 'administrativeExpenses',
        description: 'The administrative expenses of the company.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'administrative_expenses',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Selling Expenses',
        key: 'sellingExpenses',
        description: 'The selling expenses of the company.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'selling_expenses',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Other External Expenses',
        key: 'otherExternalExpenses',
        description: 'Other external expenses of the company.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'other_external_expenses',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Personnel Expenses',
        key: 'personelExpenses',
        description: 'The personnel expenses of the company.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'personel_expenses', // Note: This maintains the original typo in the database column name
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'EBIT',
        key: 'ebit',
        description: 'Earnings Before Interest and Taxes.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'ebit',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'EBITA',
        key: 'ebita',
        description: 'Earnings Before Interest, Taxes, and Amortization.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'ebita',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'EBITD',
        key: 'ebitd',
        description: 'Earnings Before Interest, Taxes, and Depreciation.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'ebitd',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'EBITDA',
        key: 'ebitda',
        description: 'Earnings Before Interest, Taxes, Depreciation, and Amortization.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'ebitda',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Depreciation and Amortization',
        key: 'deprAmo',
        description: 'Combined depreciation and amortization expenses.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'depr_amo',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Depreciation',
        key: 'depreciation',
        description: 'The depreciation expenses of the company.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'depreciation',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Amortization',
        key: 'amortisation',
        description: 'The amortization expenses of the company.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'amortisation',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Net Financial Income or Expenses',
        key: 'netFinancialIncomeOrExpenses',
        description: 'The net financial income or expenses of the company.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'net_financial_income_or_expenses',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Financial Income',
        key: 'financialIncome',
        description: 'The financial income of the company.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'financial_income',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Financial Expenses',
        key: 'financialExpenses',
        description: 'The financial expenses of the company.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'financial_expenses',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Pre-Tax Profit',
        key: 'preTaxProfit',
        description: 'Profit before taxes.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'pre_tax_profit',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Net Profit',
        key: 'netProfit',
        description: 'The net profit of the company after taxes.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'net_profit',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Cash Equivalents',
        key: 'cashEquivalents',
        description: 'Cash and cash equivalents held by the company.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'cash_equivalents',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Accounts Receivable',
        key: 'accRec',
        description: 'Accounts receivable of the company.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'acc_rec',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Inventories',
        key: 'inventories',
        description: 'Value of inventories held by the company.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'inventories',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Other Current Operating Assets',
        key: 'othCurrOpAss',
        description: 'Other current operating assets of the company.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'oth_curr_op_ass',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Current Financial Assets',
        key: 'currFinAss',
        description: 'Current financial assets of the company.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'curr_fin_ass',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Total Current Assets',
        key: 'totalCurrentAssets',
        description: 'Total value of all current assets.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'total_current_assets',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Property, Plant and Equipment',
        key: 'ppe',
        description: 'Value of property, plant, and equipment owned by the company.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'ppe',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Goodwill and Intangible Assets',
        key: 'goodwillIntangAss',
        description: 'Value of goodwill and intangible assets.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'goodwill_intang_ass',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Non-Current Financial Receivables',
        key: 'nCurrFinRec',
        description: 'Non-current financial receivables of the company.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'n_curr_fin_rec',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Other Non-Current Operating Assets',
        key: 'othNCurrOpAss',
        description: 'Other non-current operating assets of the company.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'oth_n_curr_op_ass',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Total Non-Current Assets',
        key: 'totalNonCurrentAssets',
        description: 'Total value of all non-current assets.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'total_non_current_assets',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Total Assets',
        key: 'totalAssets',
        description: 'Total value of all assets owned by the company.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'total_assets',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Accounts Payable',
        key: 'accPay',
        description: 'Accounts payable of the company.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'acc_pay',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Current Financial Liabilities',
        key: 'currFinLiab',
        description: 'Current financial liabilities of the company.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'curr_fin_liab',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Post-Employment Liabilities',
        key: 'postEmplLiab',
        description: 'Post-employment liabilities of the company.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'post_empl_liab',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Other Current Operating Liabilities',
        key: 'othCurrOpLiab',
        description: 'Other current operating liabilities of the company.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'oth_curr_op_liab',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Total Current Liabilities',
        key: 'totalCurrentLiabilities',
        description: 'Total value of all current liabilities.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'total_current_liabilities',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Other Non-Current Operating Liabilities',
        key: 'othNCurrOpLiab',
        description: 'Other non-current operating liabilities of the company.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'oth_n_curr_op_liab',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Non-Current Financial Liabilities',
        key: 'nCurrFinLiab',
        description: 'Non-current financial liabilities of the company.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'n_curr_fin_liab',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Total Non-Current Liabilities',
        key: 'totalNonCurrLiab',
        description: 'Total value of all non-current liabilities.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'total_non_curr_liab',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: "Shareholders' Equity",
        key: 'shareholdEq',
        description: "The shareholders' equity of the company.",
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'sharehold_eq',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Retained Earnings',
        key: 'retainedEarnings',
        description: 'Retained earnings of the company.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'retained_earnings',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Minority Interest',
        key: 'minInt',
        description: 'Minority interest in the company.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'min_int',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Total Equity',
        key: 'totalEquity',
        description: 'Total equity of the company.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'total_equity',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Dividends',
        key: 'dividends',
        description: 'Dividends paid by the company.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'dividends',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Cash Flow Before Financing Activities',
        key: 'cashFlowBeforeFinAct',
        description: 'Cash flow before financing activities.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'cash_flow_before_fin_act',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Operating Cash Flow',
        key: 'cashFlowOperating',
        description: 'Cash flow from operating activities.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'cash_flow_operating',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'EBIT Margin',
        key: 'ebitMargin',
        description: 'EBIT as a percentage of revenue.',
        type: 'number',
        section: 'Financial Metrics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'ebit_margin',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'EBITDA Margin',
        key: 'ebitdaMargin',
        description: 'EBITDA as a percentage of revenue.',
        type: 'number',
        section: 'Financial Metrics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'ebitda_margin',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Pre-Tax Profit Margin',
        key: 'preTaxProfitMargin',
        description: 'Pre-tax profit as a percentage of revenue.',
        type: 'number',
        section: 'Financial Metrics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'pre_tax_profit_margin',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Net Profit Margin',
        key: 'netProfitMargin',
        description: 'Net profit as a percentage of revenue.',
        type: 'number',
        section: 'Financial Metrics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'net_profit_margin',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Return on Equity',
        key: 'roe',
        description: 'Return on equity (net income divided by shareholders equity).',
        type: 'number',
        section: 'Financial Metrics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'roe',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Net Capital Expenditure',
        key: 'netCapex',
        description: 'Net capital expenditure of the company.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'net_capex',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Net Debt',
        key: 'netDebt',
        description: 'Net debt of the company (total debt minus cash and cash equivalents).',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'net_debt',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Market Cap',
        key: 'marketCap',
        description: 'Market capitalization of the company.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'market_cap',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Annual Report Number of Employees',
        key: 'annualReportNumberOfEmployees',
        description: 'Number of employees reported in the annual report.',
        type: 'number',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'annual_report_number_of_employees',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Fiscal Year Length',
        key: 'fiscalYearLength',
        description: 'Length of the fiscal year in months.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'fiscal_year_length',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Last Fiscal Year Month',
        key: 'lfyMonth',
        description: 'Month number of the last fiscal year end.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'lfy_month',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Net Change in Cash',
        key: 'netChangeInCash',
        description: 'Net change in cash during the reporting period.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'net_change_in_cash',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Net Sales Growth',
        key: 'netSalesGrowth',
        description: 'Year-over-year growth in net sales.',
        type: 'number',
        section: 'Financial Metrics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'net_sales_growth',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Compound Annual Growth Rate',
        key: 'cagr',
        description: 'Compound annual growth rate of revenue.',
        type: 'number',
        section: 'Financial Metrics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'cagr',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: '3-Year Compound Annual Growth Rate',
        key: 'cagr3',
        description: '3-year compound annual growth rate of revenue.',
        type: 'number',
        section: 'Financial Metrics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'cagr3',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'EBIT Growth',
        key: 'ebitGrowth',
        description: 'Year-over-year growth in EBIT.',
        type: 'number',
        section: 'Financial Metrics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'ebit_growth',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: '3-Year EBIT CAGR',
        key: 'cagr3ebit',
        description: '3-year compound annual growth rate of EBIT.',
        type: 'number',
        section: 'Financial Metrics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'cagr3ebit',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'EBIT CAGR',
        key: 'cagrebit',
        description: 'Compound annual growth rate of EBIT.',
        type: 'number',
        section: 'Financial Metrics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'cagrebit',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'EBITDA Growth',
        key: 'ebitdaGrowth',
        description: 'Year-over-year growth in EBITDA.',
        type: 'number',
        section: 'Financial Metrics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'ebitda_growth',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Net Profit Growth',
        key: 'netProfitGrowth',
        description: 'Year-over-year growth in net profit.',
        type: 'number',
        section: 'Financial Metrics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'net_profit_growth',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Earnings Per Share',
        key: 'eps',
        description: 'Earnings per share.',
        type: 'number',
        section: 'Financial Metrics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'eps',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Equity Ratio',
        key: 'equityRatio',
        description: 'Equity as a percentage of total assets.',
        type: 'number',
        section: 'Financial Metrics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'equity_ratio',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Net Debt to EBIT',
        key: 'netDebtToEbit',
        description: 'Net debt divided by EBIT.',
        type: 'number',
        section: 'Financial Metrics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'net_debt_to_ebit',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Net Debt to EBITDA',
        key: 'netDebtToEbitda',
        description: 'Net debt divided by EBITDA.',
        type: 'number',
        section: 'Financial Metrics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'net_debt_to_ebitda',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Net Debt to Equity',
        key: 'netDebtToEquity',
        description: 'Net debt divided by equity.',
        type: 'number',
        section: 'Financial Metrics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'net_debt_to_equity',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'EV to EBIT',
        key: 'evToEbit',
        description: 'Enterprise value divided by EBIT.',
        type: 'number',
        section: 'Financial Metrics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'ev_to_ebit',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'EV to EBITDA',
        key: 'evToEbitda',
        description: 'Enterprise value divided by EBITDA.',
        type: 'number',
        section: 'Financial Metrics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'ev_to_ebitda',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'EV to Net Sales',
        key: 'evToNetSales',
        description: 'Enterprise value divided by net sales.',
        type: 'number',
        section: 'Financial Metrics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'ev_to_net_sales',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Price to Earnings',
        key: 'pe',
        description: 'Price to earnings ratio.',
        type: 'number',
        section: 'Financial Metrics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'pe',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Enterprise Value',
        key: 'ev',
        description: 'Enterprise value of the company.',
        type: 'number',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'ev',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Price to Book Value',
        key: 'pbv',
        description: 'Price to book value ratio.',
        type: 'number',
        section: 'Financial Metrics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'pbv',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Annual Report Employee Growth',
        key: 'annualReportEmployeeGrowth',
        description: 'Year-over-year growth in employee count reported in annual reports.',
        type: 'number',
        section: 'Company Metrics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'annual_report_employee_growth',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Active Job Posts',
        key: 'activeJobposts',
        description: 'Number of active job posts by the company.',
        type: 'number',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'active_jobposts',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Domain is Verified',
        key: 'domainIsVerified',
        description: 'Indicates whether the company domain has been verified.',
        type: 'boolean',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'domain_is_verified',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Domain',
        key: 'domain',
        description: 'The domain name of the company website.',
        type: 'string',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'domain',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Final URL',
        key: 'finalUrl',
        description: 'The final URL after any redirects from the company website.',
        type: 'string',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'final_url',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Error',
        key: 'error',
        description: 'Any error encountered when accessing the company website.',
        type: 'string',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'error',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Page Load Time TTI',
        key: 'pageLoadTimeTti',
        description: 'Time to Interactive (TTI) when loading the company website.',
        type: 'number',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'page_load_time_tti',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Domain System Period',
        key: 'domainSysPeriod',
        description: 'The period for which the domain information is valid.',
        type: 'string',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'domain_sys_period',
        databaseType: 'tstzrange',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'IP Address',
        key: 'ipAddress',
        description: 'IP address of the company website server.',
        type: 'string',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'ip_address',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Universal Analytics',
        key: 'analyticsUa',
        description: 'Google Universal Analytics identifier.',
        type: 'number',
        section: 'Digital Analytics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'analytics_ua',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Google Analytics 4',
        key: 'analyticsGa4',
        description: 'Google Analytics 4 identifier.',
        type: 'number',
        section: 'Digital Analytics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'analytics_ga4',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Facebook Analytics',
        key: 'analyticsFb',
        description: 'Facebook Analytics identifier.',
        type: 'number',
        section: 'Digital Analytics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'analytics_fb',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Google Conversion Pixel Account',
        key: 'gconvpAccount',
        description: 'Google Conversion Pixel account identifier.',
        type: 'string',
        section: 'Digital Analytics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'gconvp_account',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Adobe Analytics Account',
        key: 'adobeAccount',
        description: 'Adobe Analytics account identifier.',
        type: 'string',
        section: 'Digital Analytics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'adobe_account',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Organization Image',
        key: 'orgImage',
        description: 'URL to the organization image/logo.',
        type: 'string',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'org_image',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Sitemaps',
        key: 'sitemaps',
        description: 'Information about the website sitemaps.',
        type: 'string',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'sitemaps',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Cookie Consent',
        key: 'cookieConsent',
        description: 'Indicates whether the website implements cookie consent.',
        type: 'boolean',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'cookie_consent',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Platform',
        key: 'platform',
        description: 'The platform or CMS used for the website.',
        type: 'string',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'platform',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Server',
        key: 'server',
        description: 'The server software used by the website.',
        type: 'string',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'server',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Host',
        key: 'host',
        description: 'The host of the website.',
        type: 'string',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'host',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Domain Keywords',
        key: 'domainKeywords',
        description: 'Keywords associated with the domain.',
        type: 'string',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'domain_keywords',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Description',
        key: 'description',
        description: 'Website meta description.',
        type: 'string',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'description',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Description Word Count',
        key: 'descriptionWords',
        description: 'Number of words in the website meta description.',
        type: 'number',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'description_words',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Description Character Count',
        key: 'descriptionChars',
        description: 'Number of characters in the website meta description.',
        type: 'number',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'description_chars',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    // Hosting provider
    {
        title: 'Hosting Provider',
        key: 'hostingProvider',
        description: 'The hosting provider of the website.',
        type: 'string',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'hosting_provider',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    // Hosting region
    {
        title: 'Hosting Region',
        key: 'hostingRegion',
        description: 'The region where the website is hosted.',
        type: 'string',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'hosting_region',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    // Is Ecommerce
    {
        title: 'Is Ecommerce',
        key: 'isEcommerce',
        description: 'Indicates whether the website is an ecommerce platform.',
        type: 'boolean',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'is_ecommerce',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    // eCommerce platform
    {
        title: 'Ecommerce Platform',
        key: 'ecommercePlatform',
        description: 'The ecommerce platform used by the website.',
        type: 'array',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
        databaseKey: 'ecommerce_platform',
        databaseType: 'string-array',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
    },
    {
        title: 'Uses Cookiebot',
        key: 'toolCookiebot',
        description: 'Indicates whether the website uses Cookiebot for cookie consent management.',
        type: 'boolean',
        section: 'Digital Tools',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'tool_cookiebot',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Uses CookieLaw',
        key: 'toolCookielaw',
        description: 'Indicates whether the website uses OneTrust CookieLaw for cookie consent management.',
        type: 'boolean',
        section: 'Digital Tools',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'tool_cookielaw',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Uses OneTrust',
        key: 'toolOnetrust',
        description: 'Indicates whether the website uses OneTrust for privacy management.',
        type: 'boolean',
        section: 'Digital Tools',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'tool_onetrust',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Uses DoubleClick',
        key: 'toolDoubleclick',
        description: 'Indicates whether the website uses Google DoubleClick.',
        type: 'boolean',
        section: 'Digital Tools',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'tool_doubleclick',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Uses Hotjar',
        key: 'toolHotjar',
        description: 'Indicates whether the website uses Hotjar for analytics and feedback.',
        type: 'boolean',
        section: 'Digital Tools',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'tool_hotjar',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Uses Optimizely',
        key: 'toolOptimizely',
        description: 'Indicates whether the website uses Optimizely for A/B testing.',
        type: 'boolean',
        section: 'Digital Tools',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'tool_optimizely',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Uses Ebbot',
        key: 'toolEbbot',
        description: 'Indicates whether the website uses Ebbot for chatbot functionality.',
        type: 'boolean',
        section: 'Digital Tools',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'tool_ebbot',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Uses Intercom',
        key: 'toolIntercom',
        description: 'Indicates whether the website uses Intercom for customer messaging.',
        type: 'boolean',
        section: 'Digital Tools',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'tool_intercom',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Uses Klaviyo',
        key: 'toolKlaviyo',
        description: 'Indicates whether the website uses Klaviyo for email marketing.',
        type: 'boolean',
        section: 'Digital Tools',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'tool_klaviyo',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Uses HubSpot',
        key: 'toolHubspot',
        description: 'Indicates whether the website uses HubSpot for CRM, marketing automation, and customer service.',
        type: 'boolean',
        section: 'Digital Tools',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'tool_hubspot',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Uses Marketo',
        key: 'toolMarketo',
        description: 'Indicates whether the website uses Marketo for marketing automation.',
        type: 'boolean',
        section: 'Digital Tools',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'tool_marketo',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Uses Salesforce',
        key: 'toolSalesforce',
        description: 'Indicates whether the website uses Salesforce for CRM and marketing.',
        type: 'boolean',
        section: 'Digital Tools',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'tool_salesforce',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Uses Trustpilot',
        key: 'toolTrustpilot',
        description: 'Indicates whether the website uses Trustpilot for reviews and ratings.',
        type: 'boolean',
        section: 'Digital Tools',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'tool_trustpilot',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Uses Custobar',
        key: 'toolCustobar',
        description: 'Indicates whether the website uses Custobar for marketing automation.',
        type: 'boolean',
        section: 'Digital Tools',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'tool_custobar',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Uses Voyado',
        key: 'toolVoyado',
        description: 'Indicates whether the website uses Voyado for CRM and marketing.',
        type: 'boolean',
        section: 'Digital Tools',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'tool_voyado',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Uses GoDaddy',
        key: 'toolGodaddy',
        description: 'Indicates whether the website uses GoDaddy for hosting or website building.',
        type: 'boolean',
        section: 'Digital Tools',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'tool_godaddy',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Uses Shopify',
        key: 'toolShopify',
        description: 'Indicates whether the website uses Shopify for e-commerce.',
        type: 'boolean',
        section: 'Digital Tools',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'tool_shopify',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Uses Squarespace',
        key: 'toolSquarespace',
        description: 'Indicates whether the website uses Squarespace for website building.',
        type: 'boolean',
        section: 'Digital Tools',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'tool_squarespace',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Uses Wix',
        key: 'toolWix',
        description: 'Indicates whether the website uses Wix for website building.',
        type: 'boolean',
        section: 'Digital Tools',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'tool_wix',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Uses WordPress',
        key: 'toolWordpress',
        description: 'Indicates whether the website uses WordPress as a CMS.',
        type: 'boolean',
        section: 'Digital Tools',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'tool_wordpress',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Uses Seenthis',
        key: 'toolSeenthis',
        description: 'Indicates whether the website uses Seenthis for reviews and UGC.',
        type: 'boolean',
        section: 'Digital Tools',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'tool_seenthis',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Uses Yotpo',
        key: 'toolYotpo',
        description: 'Indicates whether the website uses Yotpo for reviews, loyalty, and SMS marketing.',
        type: 'boolean',
        section: 'Digital Tools',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'tool_yotpo',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Uses Apprl',
        key: 'toolApprl',
        description: 'Indicates whether the website uses Apprl for influencer marketing.',
        type: 'boolean',
        section: 'Digital Tools',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'tool_apprl',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Uses Criteo',
        key: 'toolCriteo',
        description: 'Indicates whether the website uses Criteo for retargeting ads.',
        type: 'boolean',
        section: 'Digital Tools',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'tool_criteo',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Uses Reco',
        key: 'toolReco',
        description: 'Indicates whether the website uses Reco for recommendations.',
        type: 'boolean',
        section: 'Digital Tools',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'tool_reco',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Requested Hosts',
        key: 'requestedHosts',
        description: 'List of hosts that the website made requests to.',
        type: 'array',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
        databaseKey: 'requested_hosts',
        databaseType: 'string-array',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
    },
    {
        title: 'Google Tag Manager',
        key: 'analyticsGtm',
        description: 'Google Tag Manager identifier.',
        type: 'number',
        section: 'Digital Analytics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'analytics_gtm',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Google Ads',
        key: 'analyticsAw',
        description: 'Google Ads identifier.',
        type: 'number',
        section: 'Digital Analytics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'analytics_aw',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Uses Google Tag Manager',
        key: 'toolGoogletagmanager',
        description: 'Indicates whether the website uses Google Tag Manager.',
        type: 'boolean',
        section: 'Digital Tools',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'tool_googletagmanager',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Document Size',
        key: 'sizeDocument',
        description: 'Size of the HTML document in bytes.',
        type: 'number',
        section: 'Website Performance',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'size_document',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Script Size',
        key: 'sizeScript',
        description: 'Size of JavaScript resources in bytes.',
        type: 'number',
        section: 'Website Performance',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'size_script',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Stylesheet Size',
        key: 'sizeStylesheet',
        description: 'Size of CSS resources in bytes.',
        type: 'number',
        section: 'Website Performance',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'size_stylesheet',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Image Size',
        key: 'sizeImage',
        description: 'Size of image resources in bytes.',
        type: 'number',
        section: 'Website Performance',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'size_image',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Media Size',
        key: 'sizeMedia',
        description: 'Size of media resources in bytes.',
        type: 'number',
        section: 'Website Performance',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'size_media',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Page Title',
        key: 'title',
        description: 'Title of the company website homepage.',
        type: 'string',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'title',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Title Word Count',
        key: 'titleWords',
        description: 'Number of words in the page title.',
        type: 'number',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'title_words',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Title Character Count',
        key: 'titleChars',
        description: 'Number of characters in the page title.',
        type: 'number',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'title_chars',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Favicon',
        key: 'favicon',
        description: 'URL of the website favicon.',
        type: 'string',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'favicon',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Canonical URL',
        key: 'canonical',
        description: 'Canonical URL of the website homepage.',
        type: 'string',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'canonical',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Robots Meta Tag',
        key: 'robots',
        description: 'Content of the robots meta tag.',
        type: 'string',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'robots',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'No Index',
        key: 'noindex',
        description: 'Alternative field indicating whether the website has a noindex directive.',
        type: 'boolean',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'noindex',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Internal Links',
        key: 'internalLinks',
        description: 'Number of internal links on the website.',
        type: 'number',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'internal_links',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'External Links',
        key: 'externalLinks',
        description: 'Number of external links on the website.',
        type: 'number',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'external_links',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Matomo Analytics',
        key: 'analyticsMo',
        description: 'Matomo/Piwik Analytics identifier.',
        type: 'number',
        section: 'Digital Analytics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'analytics_mo',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Language',
        key: 'lang',
        description: 'Primary language of the website.',
        type: 'string',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'lang',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Adobe Analytics',
        key: 'analyticsAdobe',
        description: 'Adobe Analytics identifier.',
        type: 'number',
        section: 'Digital Analytics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'analytics_adobe',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Font Colors',
        key: 'colorsFont',
        description: 'List of font colors used on the website.',
        type: 'array',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
        databaseKey: 'colors_font',
        databaseType: 'string-array',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
    },
    {
        title: 'Page Colors',
        key: 'colorsPage',
        description: 'List of background and design colors used on the website.',
        type: 'array',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
        databaseKey: 'colors_page',
        databaseType: 'string-array',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
    },
    {
        title: 'SVG Colors',
        key: 'colorsSvg',
        description: 'List of colors used in SVG elements on the website.',
        type: 'array',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
        databaseKey: 'colors_svg',
        databaseType: 'string-array',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
    },
    {
        title: 'Accessibility Violation Score',
        key: 'accessViolationScore',
        description: 'Score indicating the level of accessibility violations on the website.',
        type: 'number',
        section: 'Accessibility',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'access_violation_score',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Accessibility Violations',
        key: 'violations',
        description: 'List of accessibility violations detected on the website.',
        type: 'array',
        section: 'Accessibility',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
        databaseKey: 'violations',
        databaseType: 'string-array',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
    },
    {
        title: 'Image Alt Text Ratio',
        key: 'imgAltRatio',
        description: 'Ratio of images with alt text to total images on the website.',
        type: 'number',
        section: 'Accessibility',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'img_alt_ratio',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Optimizely Analytics',
        key: 'analyticsOpt',
        description: 'Optimizely Analytics identifier.',
        type: 'number',
        section: 'Digital Analytics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'analytics_opt',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Amplitude Analytics',
        key: 'analyticsAmplitude',
        description: 'Amplitude Analytics identifier.',
        type: 'number',
        section: 'Digital Analytics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'analytics_amplitude',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Snowplow Analytics',
        key: 'analyticsSnowplow',
        description: 'Snowplow Analytics identifier.',
        type: 'number',
        section: 'Digital Analytics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'analytics_snowplow',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Trackers Before Consent',
        key: 'trackersBeforeConsent',
        description: 'List of trackers loaded before user consent was given.',
        type: 'array',
        section: 'Privacy',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
        databaseKey: 'trackers_before_consent',
        databaseType: 'string-array',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
    },
    {
        title: 'Trackers Before Consent Count',
        key: 'trackersBeforeConsentCount',
        description: 'Number of trackers loaded before user consent was given.',
        type: 'number',
        section: 'Privacy',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'trackers_before_consent_count',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Time to First Byte',
        key: 'webVitalsTtfb',
        description: 'Time to First Byte (TTFB) web vital metric in milliseconds.',
        type: 'number',
        section: 'Website Performance',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'web_vitals_ttfb',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'First Contentful Paint',
        key: 'webVitalsFcp',
        description: 'First Contentful Paint (FCP) web vital metric in milliseconds.',
        type: 'number',
        section: 'Website Performance',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'web_vitals_fcp',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Largest Contentful Paint',
        key: 'webVitalsLcp',
        description: 'Largest Contentful Paint (LCP) web vital metric in milliseconds.',
        type: 'number',
        section: 'Website Performance',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'web_vitals_lcp',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Cumulative Layout Shift',
        key: 'webVitalsCls',
        description: 'Cumulative Layout Shift (CLS) web vital metric.',
        type: 'number',
        section: 'Website Performance',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'web_vitals_cls',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Time to Interactive',
        key: 'webVitalsTti',
        description: 'Time to Interactive (TTI) web vital metric in milliseconds.',
        type: 'number',
        section: 'Website Performance',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'web_vitals_tti',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Interaction to Next Paint',
        key: 'webVitalsInp',
        description: 'Interaction to Next Paint (INP) web vital metric in milliseconds.',
        type: 'number',
        section: 'Website Performance',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'web_vitals_inp',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Detected Languages',
        key: 'detectedLanguages',
        description: 'List of languages detected on the website.',
        type: 'array',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
        databaseKey: 'detected_languages',
        databaseType: 'string-array',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
    },
    {
        title: 'Language Count',
        key: 'languageCount',
        description: 'Number of different languages detected on the website.',
        type: 'number',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'language_count',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'H1 Content',
        key: 'h1Content',
        description: 'Text content of H1 headings on the website.',
        type: 'array',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
        databaseKey: 'h_1_content',
        databaseType: 'string-array',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
    },
    {
        title: 'H1 Content Word Counts',
        key: 'h1ContentWords',
        description: 'Word counts for each H1 heading on the website.',
        type: 'array',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.Number), { onNoneEncoding: null }),
        databaseKey: 'h_1_content_words',
        databaseType: 'numeric-array',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.Number), { onNoneEncoding: null }),
    },
    {
        title: 'H1 Content Character Counts',
        key: 'h1ContentChars',
        description: 'Character counts for each H1 heading on the website.',
        type: 'array',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.Number), { onNoneEncoding: null }),
        databaseKey: 'h_1_content_chars',
        databaseType: 'numeric-array',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.Number), { onNoneEncoding: null }),
    },
    {
        title: 'H1 Count',
        key: 'h1Count',
        description: 'Number of H1 headings on the website.',
        type: 'number',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'h_1_count',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'H2 Count',
        key: 'h2Count',
        description: 'Number of H2 headings on the website.',
        type: 'number',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'h_2_count',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'H3 Count',
        key: 'h3Count',
        description: 'Number of H3 headings on the website.',
        type: 'number',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'h_3_count',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Sitemap',
        key: 'sitemap',
        description: 'URL of the website sitemap.',
        type: 'string',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'sitemap',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Sitemap Count',
        key: 'sitemapCount',
        description: 'Number of sitemaps detected on the website.',
        type: 'number',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'sitemap_count',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Sitemap URL Count',
        key: 'sitemapUrlCount',
        description: 'Number of URLs listed in the website sitemaps.',
        type: 'number',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'sitemap_url_count',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'DNS A Records',
        key: 'dnsA',
        description: 'A records in the domain DNS.',
        type: 'array',
        section: 'Digital Infrastructure',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
        databaseKey: 'dns_a',
        databaseType: 'string-array',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
    },
    {
        title: 'DNS AAAA Records',
        key: 'dnsAaaa',
        description: 'AAAA records in the domain DNS.',
        type: 'array',
        section: 'Digital Infrastructure',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
        databaseKey: 'dns_aaaa',
        databaseType: 'string-array',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
    },
    {
        title: 'DNS NS Records',
        key: 'dnsNs',
        description: 'NS records in the domain DNS.',
        type: 'array',
        section: 'Digital Infrastructure',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
        databaseKey: 'dns_ns',
        databaseType: 'string-array',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
    },
    {
        title: 'DNS SOA Record',
        key: 'dnsSoa',
        description: 'SOA record in the domain DNS.',
        type: 'string',
        section: 'Digital Infrastructure',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'dns_soa',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'DNS MX Record',
        key: 'dnsMx',
        description: 'MX record in the domain DNS.',
        type: 'string',
        section: 'Digital Infrastructure',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'dns_mx',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Email Provider',
        key: 'emailProvider',
        description: 'Email service provider used by the company.',
        type: 'string',
        section: 'Digital Infrastructure',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'email_provider',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'DNS SPF Records',
        key: 'dnsSpf',
        description: 'SPF records in the domain DNS for email authentication.',
        type: 'array',
        section: 'Digital Infrastructure',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
        databaseKey: 'dns_spf',
        databaseType: 'string-array',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
    },
    {
        title: 'Has DMARC',
        key: 'dnsDmarc',
        description: 'Indicates whether the domain has DMARC email authentication configured.',
        type: 'boolean',
        section: 'Digital Infrastructure',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'dns_dmarc',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'DMARC Level',
        key: 'dnsDmarcLevel',
        description: 'Level of DMARC policy enforcement (none/quarantine/reject).',
        type: 'string',
        section: 'Digital Infrastructure',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'dns_dmarc_level',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'DMARC Details',
        key: 'dnsDmarcDetails',
        description: 'Detailed information about the DMARC configuration.',
        type: 'string',
        section: 'Digital Infrastructure',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'dns_dmarc_details',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Has DKIM',
        key: 'dnsDkim',
        description: 'Indicates whether the domain has DKIM email authentication configured.',
        type: 'boolean',
        section: 'Digital Infrastructure',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'dns_dkim',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'DKIM Selector',
        key: 'dnsDkimSelector',
        description: 'DKIM selector used for email authentication.',
        type: 'string',
        section: 'Digital Infrastructure',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'dns_dkim_selector',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'DKIM Level',
        key: 'dnsDkimLevel',
        description: 'Level of DKIM policy enforcement.',
        type: 'string',
        section: 'Digital Infrastructure',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'dns_dkim_level',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'DKIM Details',
        key: 'dnsDkimDetails',
        description: 'Detailed information about the DKIM configuration.',
        type: 'string',
        section: 'Digital Infrastructure',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'dns_dkim_details',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'DNS Verifications',
        key: 'dnsVerifications',
        description: 'List of domain verification records found in DNS.',
        type: 'array',
        section: 'Digital Infrastructure',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
        databaseKey: 'dns_verifications',
        databaseType: 'string-array',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
    },
    {
        title: 'Font Size',
        key: 'sizeFont',
        description: 'Size of font resources in bytes.',
        type: 'number',
        section: 'Website Performance',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'size_font',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'XHR Size',
        key: 'sizeXhr',
        description: 'Size of XMLHttpRequest resources in bytes.',
        type: 'number',
        section: 'Website Performance',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'size_xhr',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Ping Size',
        key: 'sizePing',
        description: 'Size of ping resources in bytes.',
        type: 'number',
        section: 'Website Performance',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'size_ping',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Fetch Size',
        key: 'sizeFetch',
        description: 'Size of fetch resources in bytes.',
        type: 'number',
        section: 'Website Performance',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'size_fetch',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Other Resources Size',
        key: 'sizeOther',
        description: 'Size of other resources in bytes.',
        type: 'number',
        section: 'Website Performance',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'size_other',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'X-Robots-Tag',
        key: 'xRobotsTag',
        description: 'Content of the X-Robots-Tag HTTP header.',
        type: 'string',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'x_robots_tag',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Framework',
        key: 'framework',
        description: 'Web framework used for the website.',
        type: 'string',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'framework',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Cookies',
        key: 'cookies',
        description: 'Information about cookies used on the website.',
        type: 'string',
        section: 'Privacy',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'cookies',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Has Schema Script',
        key: 'hasSchemaScript',
        description: 'Indicates whether the website has structured data using schema.org markup.',
        type: 'boolean',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'has_schema_script',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Image Count',
        key: 'imgCount',
        description: 'Total number of images on the website.',
        type: 'number',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'img_count',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Images with Alt Text',
        key: 'imgAltCount',
        description: 'Number of images with alt text on the website.',
        type: 'number',
        section: 'Accessibility',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'img_alt_count',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Images Missing Alt Text',
        key: 'imgMissingAltCount',
        description: 'Number of images missing alt text on the website.',
        type: 'number',
        section: 'Accessibility',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'img_missing_alt_count',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Images with Title Attribute',
        key: 'imgTitleCount',
        description: 'Number of images with title attributes on the website.',
        type: 'number',
        section: 'Digital Presence',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'img_title_count',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Snapchat Handle',
        key: 'snapchatHandle',
        description: 'Snapchat username(s) associated with the company.',
        type: 'array',
        section: 'Social Media',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
        databaseKey: 'snapchat_handle',
        databaseType: 'string-array',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
    },
    {
        title: 'LinkedIn Verified',
        key: 'linkedinIsVerified',
        description: 'Indicates whether the LinkedIn company page is verified.',
        type: 'boolean',
        section: 'Social Media',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'linkedin_is_verified',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'LinkedIn ID',
        key: 'linkedinId',
        description: 'Unique identifier for the company LinkedIn page.',
        type: 'string',
        section: 'Social Media',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'linkedin_id',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'LinkedIn Domain',
        key: 'linkedinDomain',
        description: 'Domain associated with the LinkedIn company page.',
        type: 'string',
        section: 'Social Media',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'linkedin_domain',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'LinkedIn Industry',
        key: 'linkedinIndustry',
        description: 'Industry category from LinkedIn company page.',
        type: 'string',
        section: 'Social Media',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'linkedin_industry',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'LinkedIn Employee Count',
        key: 'linkedinNumberOfEmployees',
        description: 'Number of employees according to LinkedIn.',
        type: 'number',
        section: 'Social Media',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'linkedin_number_of_employees',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'LinkedIn 3-Month Employee Growth',
        key: 'linkedinAllEmployeeGrowth3Months',
        description: 'Employee growth rate over the last 3 months according to LinkedIn.',
        type: 'number',
        section: 'Social Media',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'linkedin_all_employee_growth_3_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'LinkedIn 6-Month Employee Growth',
        key: 'linkedinAllEmployeeGrowth6Months',
        description: 'Employee growth rate over the last 6 months according to LinkedIn.',
        type: 'number',
        section: 'Social Media',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'linkedin_all_employee_growth_6_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'LinkedIn 1-Year Employee Growth',
        key: 'linkedinAllEmployeeGrowth1Year',
        description: 'Employee growth rate over the last year according to LinkedIn.',
        type: 'number',
        section: 'Social Media',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'linkedin_all_employee_growth_1_year',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'LinkedIn 2-Year Employee Growth',
        key: 'linkedinAllEmployeeGrowth2Years',
        description: 'Employee growth rate over the last 2 years according to LinkedIn.',
        type: 'number',
        section: 'Social Media',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'linkedin_all_employee_growth_2_years',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Number of Employees',
        key: 'numberOfEmployees',
        description: 'Total number of employees at the company from consolidated sources.',
        type: 'number',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'number_of_employees',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Number of Employees Source',
        key: 'numberOfEmployeesSource',
        description: 'Source of the employee count information.',
        type: 'string',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'number_of_employees_source',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Identified Organisation Numbers in Company Group',
        key: 'identifiedOrgnrCount',
        description: 'Number of identified organisation numbers in the Valu8 company group.',
        type: 'number',
        section: 'Company Group',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'identified_orgnr_count',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Company Group Size Change (6 Months)',
        key: 'identifiedOrgnrDelta6m',
        description: 'Change in identified organisation numbers in the Valu8 company group over 6 months.',
        type: 'number',
        section: 'Company Group',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'identified_orgnr_delta_6m',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Company Group Size Change (1 Year)',
        key: 'identifiedOrgnrDelta1y',
        description: 'Change in identified organisation numbers in the Valu8 company group over 1 year.',
        type: 'number',
        section: 'Company Group',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'identified_orgnr_delta_1y',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Company Group Size Change (3 Years)',
        key: 'identifiedOrgnrDelta3y',
        description: 'Change in identified organisation numbers in the Valu8 company group over 3 years.',
        type: 'number',
        section: 'Company Group',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'identified_orgnr_delta_3y',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Company Group Size Change (5 Years)',
        key: 'identifiedOrgnrDelta5y',
        description: 'Change in identified organisation numbers in the Valu8 company group over 5 years.',
        type: 'number',
        section: 'Company Group',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'identified_orgnr_delta_5y',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Company Buzz Count',
        key: 'companyBuzzCount',
        description: 'Count of buzz events related to the company.',
        type: 'number',
        section: 'Company Buzz',
        nullable: false,
        schema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_count',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Company Is Raising Capital',
        key: 'companyBuzzIsRaisingCapital',
        description: 'Indicates whether the company is currently raising capital.',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_raising_capital',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Is Going IPO',
        key: 'companyBuzzIsIpo',
        description: 'Indicates whether the company is going public (IPO).',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_ipo',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Is In Merger',
        key: 'companyBuzzIsMerger',
        description: 'Indicates whether the company is involved in a merger or acquisition.',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_merger',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Is Moving',
        key: 'companyBuzzIsMoving',
        description: 'Indicates whether the company is relocating.',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_moving',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Is Hiring',
        key: 'companyBuzzIsHiring',
        description: 'Indicates whether the company is actively hiring.',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_hiring',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Is Firing',
        key: 'companyBuzzIsFiring',
        description: 'Indicates whether the company is reducing workforce.',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_firing',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Is Closing',
        key: 'companyBuzzIsClosing',
        description: 'Indicates whether the company is closing operations.',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_closing',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Is Opening',
        key: 'companyBuzzIsOpening',
        description: 'Indicates whether the company is opening new locations.',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_opening',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Is Expanding',
        key: 'companyBuzzIsExpanding',
        description: 'Indicates whether the company is expanding its operations.',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_expanding',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Is Downsizing',
        key: 'companyBuzzIsDownsizing',
        description: 'Indicates whether the company is downsizing its operations.',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_downsizing',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Is Restructuring',
        key: 'companyBuzzIsRestructuring',
        description: 'Indicates whether the company is undergoing restructuring.',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_restructuring',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Is Introducing New Product',
        key: 'companyBuzzIsNewProductIntro',
        description: 'Indicates whether the company is introducing new products or services.',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_new_product_intro',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Has Moved',
        key: 'companyBuzzHasMoved',
        description: 'Indicates whether the company has recently moved.',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_has_moved',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Is Changing CEO',
        key: 'companyBuzzIsChangingCeo',
        description: 'Indicates whether the company is changing its CEO.',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_changing_ceo',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Is Changing Board',
        key: 'companyBuzzIsChangingBoard',
        description: 'Indicates whether the company is changing its board of directors.',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_changing_board',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Is Changing Management Team',
        key: 'companyBuzzIsChangingManagementTeam',
        description: 'Indicates whether the company is changing its management team.',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_changing_management_team',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Growth - New Geographies',
        key: 'companyBuzzIsGrowthGeog',
        description: 'Expansion into new geographies (new countries, regions, offices).',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_growth_geog',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Growth - New Segments',
        key: 'companyBuzzIsGrowthSeg',
        description: 'Entering or targeting new customer / industry segments or verticals.',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_growth_seg',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Pricing Model Change',
        key: 'companyBuzzIsPricingModel',
        description: 'Changes to pricing or monetization model (e.g. subscription shift, tier revamp).',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_pricing_model',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Partnership Activity',
        key: 'companyBuzzIsPartnership',
        description: 'Strategic partnership, alliance, reseller or ecosystem collaboration announced.',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_partnership',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company M&A Activity',
        key: 'companyBuzzIsMAndA',
        description: 'Broader M&A activity (acquisitions or mergers in process or completed).',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_m_and_a',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Divestiture Activity',
        key: 'companyBuzzIsDivest',
        description: 'Divestiture or asset/business unit sale / spin‑off activity.',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_divest',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Cost Saving Initiative',
        key: 'companyBuzzIsCostSave',
        description: 'Cost saving / efficiency initiative (optimization, expense reduction).',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_cost_save',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Restructuring Initiative',
        key: 'companyBuzzIsRestruct',
        description: 'Organizational or structural change initiative (reorg, realignment).',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_restruct',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Layoff Event',
        key: 'companyBuzzIsLayoff',
        description: 'Layoff / workforce reduction event or announcement.',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_layoff',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Hiring Plan',
        key: 'companyBuzzIsHirePlan',
        description: 'Forward-looking hiring or headcount expansion plan (planned recruiting surge).',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_hire_plan',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Leadership Changes',
        key: 'companyBuzzIsLeadership',
        description: 'Leadership / senior management changes (beyond CEO/board specifics).',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_leadership',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Capex Scale-Up',
        key: 'companyBuzzIsCapexScale',
        description: 'Significant capital expenditure or scale-up of physical / technical infrastructure.',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_capex_scale',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Supply Chain Action',
        key: 'companyBuzzIsSupplyChain',
        description: 'Supply chain actions, disruptions, reshoring, logistics optimization.',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_supply_chain',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Digital / AI Initiative',
        key: 'companyBuzzIsDigiAi',
        description: 'Digital transformation / AI adoption, deployment or capability expansion.',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_digi_ai',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company ESG Target Update',
        key: 'companyBuzzIsEsgTarget',
        description: 'Announcement or update of ESG / sustainability targets or goals.',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_esg_target',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company ESG Event',
        key: 'companyBuzzIsEsgEvent',
        description: 'ESG-related milestone, certification, initiative launch or recognition.',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_esg_event',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Regulatory Change',
        key: 'companyBuzzIsRegChange',
        description: 'Regulatory / compliance change impacting operations or disclosures.',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_reg_change',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Litigation Event',
        key: 'companyBuzzIsLitigation',
        description: 'Litigation, legal dispute, investigation or court proceeding surfaced.',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_litigation',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Financing Raise',
        key: 'companyBuzzIsFinRaise',
        description: 'Financing round / capital raise (often equity/venture style).',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_fin_raise',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Dividend Policy Change',
        key: 'companyBuzzIsDivPolicy',
        description: 'Dividend policy introduction, update, suspension or change.',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_div_policy',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Revenue Guidance Update',
        key: 'companyBuzzIsRevGuide',
        description: 'Issuance or revision of revenue guidance / outlook.',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_rev_guide',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Revenue Mix Shift',
        key: 'companyBuzzIsRevMix',
        description: 'Notable shift or commentary on revenue mix (product/service/geography composition).',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_rev_mix',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Major Customer Win',
        key: 'companyBuzzIsCustMega',
        description: 'Major / marquee customer win, renewal or mega-deal announcement.',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_cust_mega',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Company Macro / External Risk Statement',
        key: 'companyBuzzIsRiskMacro',
        description: 'Statements about macro / external risk factors (economic, geopolitical, inflation, FX).',
        type: 'boolean',
        section: 'Company Buzz',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'company_buzz_is_risk_macro',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'ML Likely to Move Probability',
        key: 'mlLikelyToMoveProbability',
        description: 'Machine learning generated probability that the company will move locations.',
        type: 'number',
        section: 'Machine Learning',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'ml_likely_to_move_probability',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'ML Is Likely to Move',
        key: 'mlIsLikelyToMove',
        description: 'Machine learning prediction of whether the company is likely to move locations.',
        type: 'boolean',
        section: 'Machine Learning',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'ml_is_likely_to_move',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Move In Date Current Office',
        key: 'moveInDateCurrentOffice',
        description: 'Date when the company moved into their current office.',
        type: 'string',
        section: 'Office Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(exports.DateTimeUtcFromString, { onNoneEncoding: null }),
        databaseKey: 'move_in_date_current_office',
        databaseType: 'date',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.DateTimeUtcFromDate, { onNoneEncoding: null }),
    },
    {
        title: 'Move Date or Lease Expiration Date',
        key: 'moveDateOrLeaseExpirationDate',
        description: 'Expected move date or lease expiration date for the company.',
        type: 'string',
        section: 'Office Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(exports.DateTimeUtcFromString, { onNoneEncoding: null }),
        databaseKey: 'move_date_or_lease_expiration_date',
        databaseType: 'date',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.DateTimeUtcFromDate, { onNoneEncoding: null }),
    },
    {
        title: 'Move Date or Lease Expiration Date Is Within One Year',
        key: 'moveDateOrLeaseExpirationDateIsWithinOneYear',
        description: 'Indicates whether the move date or lease expiration is within the next year.',
        type: 'boolean',
        section: 'Office Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'move_date_or_lease_expiration_date_is_within_one_year',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Move Date or Lease Expiration Date Has Passed',
        key: 'moveDateOrLeaseExpirationDateHasPassed',
        description: 'Indicates whether the move date or lease expiration has already passed.',
        type: 'boolean',
        section: 'Office Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'move_date_or_lease_expiration_date_has_passed',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Is More Than 5 Years Since Move In Date Current Office',
        key: 'isMoreThan5YearsSinceMoveInDateCurrentOffice',
        description: 'Indicates whether the company has been in its current office for more than 5 years.',
        type: 'boolean',
        section: 'Office Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'is_more_than_5_years_since_move_in_date_current_office',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Workspace Size in m²',
        key: 'workspaceSizeInM2',
        description: 'Total workspace size in square meters.',
        type: 'number',
        section: 'Office Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'workspace_size_in_m2',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Workspace Size in m² per Employee',
        key: 'workspaceSizeInM2PerEmployee',
        description: 'Workspace size in square meters per employee.',
        type: 'number',
        section: 'Office Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'workspace_size_in_m2_per_employee',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'NorNorm Web Visitors Lead Quality',
        key: 'nornormWebVisitorsLeadQuality',
        description: 'Quality score of web visitors as potential leads for NorNorm.',
        type: 'number',
        section: 'NorNorm Data',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'nornorm_web_visitors_lead_quality',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'NorNorm Web Visitors Number of Visits',
        key: 'nornormWebVisitorsNumberOfVisits',
        description: 'Number of visits to NorNorm website from this company.',
        type: 'number',
        section: 'NorNorm Data',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'nornorm_web_visitors_number_of_visits',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'NorNorm Web Visitors Country Code',
        key: 'nornormWebVisitorsCountryCode',
        description: 'Country code of web visitors to NorNorm website from this company.',
        type: 'string',
        section: 'NorNorm Data',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'nornorm_web_visitors_country_code',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'NorNorm Web Visitors Last Visit Date',
        key: 'nornormWebVisitorsLastVisitDate',
        description: 'Date of the last visit to NorNorm website from this company.',
        type: 'string',
        section: 'NorNorm Data',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(exports.DateTimeUtcFromString, { onNoneEncoding: null }),
        databaseKey: 'nornorm_web_visitors_last_visit_date',
        databaseType: 'date',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.DateTimeUtcFromDate, { onNoneEncoding: null }),
    },
    {
        title: 'NorNorm Web Visitors First Visit Date',
        key: 'nornormWebVisitorsFirstVisitDate',
        description: 'Date of the first visit to NorNorm website from this company.',
        type: 'string',
        section: 'NorNorm Data',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(exports.DateTimeUtcFromString, { onNoneEncoding: null }),
        databaseKey: 'nornorm_web_visitors_first_visit_date',
        databaseType: 'date',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.DateTimeUtcFromDate, { onNoneEncoding: null }),
    },
    {
        title: 'Active Job Posts Per Employee',
        key: 'activeJobpostsPerEmployee',
        description: 'Ratio of active job postings to current employees.',
        type: 'number',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'active_jobposts_per_employee',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: '6sense Phone',
        key: '_6SensePhone',
        description: 'Phone number from 6sense data.',
        type: 'string',
        section: '6sense Data',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: '_6_sense_phone',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: '6sense City',
        key: '_6SenseCity',
        description: 'City from 6sense data.',
        type: 'string',
        section: '6sense Data',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: '_6_sense_city',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: '6sense Description',
        key: '_6SenseDescription',
        description: 'Company description from 6sense data.',
        type: 'string',
        section: '6sense Data',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: '_6_sense_description',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: '6sense Company Type',
        key: '_6SenseCompanyType',
        description: 'Company type from 6sense data.',
        type: 'string',
        section: '6sense Data',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: '_6_sense_company_type',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: '6sense Industry',
        key: '_6SenseIndustry',
        description: 'Industry classification from 6sense data.',
        type: 'string',
        section: '6sense Data',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: '_6_sense_industry',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: '6sense Continent',
        key: '_6SenseContinent',
        description: 'Continent from 6sense data.',
        type: 'string',
        section: '6sense Data',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: '_6_sense_continent',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: '6sense Employee Range',
        key: '_6SenceEmployeeRange',
        description: 'Range of employee count from 6sense data.',
        type: 'array',
        section: '6sense Data',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.Number), { onNoneEncoding: null }),
        databaseKey: '_6_sence_employee_range',
        databaseType: 'numeric-array',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.ArrayFromString, { onNoneEncoding: null }),
    },
    {
        title: '6sense NAICS',
        key: '_6SenseNaics',
        description: 'North American Industry Classification System code from 6sense data.',
        type: 'string',
        section: '6sense Data',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: '_6_sense_naics',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: '6sense Products or Services',
        key: '_6SenseProductsOrServices',
        description: 'Products or services provided by the company from 6sense data.',
        type: 'array',
        section: '6sense Data',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
        databaseKey: '_6_sense_products_or_services',
        databaseType: 'string-array',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
    },
    {
        title: '6sense SIC',
        key: '_6SenseSic',
        description: 'Standard Industrial Classification code from 6sense data.',
        type: 'string',
        section: '6sense Data',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: '_6_sense_sic',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: '6sense Stock Exchange',
        key: '_6SenseStockExchange',
        description: 'Stock exchange where the company is listed from 6sense data.',
        type: 'string',
        section: '6sense Data',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: '_6_sense_stock_exchange',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: '6sense Stock Symbol',
        key: '_6SenseStockSymbol',
        description: 'Stock symbol of the company from 6sense data.',
        type: 'string',
        section: '6sense Data',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: '_6_sense_stock_symbol',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: '6sense Web Technologies',
        key: '_6SenseWebTechnologies',
        description: 'Web technologies used by the company from 6sense data.',
        type: 'array',
        section: '6sense Data',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
        databaseKey: '_6_sense_web_technologies',
        databaseType: 'string-array',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
    },
    {
        title: '6sense Total Funding Range',
        key: '_6SenseTotalFundingRange',
        description: 'Range of total funding received by the company from 6sense data.',
        type: 'string',
        section: '6sense Data',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: '_6_sense_total_funding_range',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: '6sense Year Founded',
        key: '_6SenseYearFounded',
        description: 'Year the company was founded from 6sense data.',
        type: 'number',
        section: '6sense Data',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: '_6_sense_year_founded',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Percent Employees With More Than 10 Years Experience',
        key: 'percentEmployeesWithMoreThan10YearsExperience',
        description: 'Percentage of employees with more than 10 years of professional experience.',
        type: 'number',
        section: 'Company Metrics',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'percent_employees_with_more_than_10_years_experience',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Has On-site Requirements',
        key: 'hasOnSiteRequirements',
        description: 'Indicates whether the company requires employees to work on-site.',
        type: 'boolean',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'has_on_site_requirements',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Recent Funding',
        key: 'recentFunding',
        description: 'Indicates whether the company has received funding recently.',
        type: 'boolean',
        section: 'Financial Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'recent_funding',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'NorNorm Keyword Search',
        key: 'nornormKeywordSearch',
        description: 'Indicates whether the company has searched for NorNorm-related keywords.',
        type: 'boolean',
        section: 'NorNorm Data',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'nornorm_keyword_search',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'NorNorm Researched Office',
        key: 'nornormResearchedOffice',
        description: "Indicates whether NorNorm has researched this company's office needs.",
        type: 'boolean',
        section: 'NorNorm Data',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'nornorm_researched_office',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'NorNorm Researched Furniture',
        key: 'nornormResearchedFurniture',
        description: "Indicates whether NorNorm has researched this company's furniture needs.",
        type: 'boolean',
        section: 'NorNorm Data',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'nornorm_researched_furniture',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Looking For Office',
        key: 'lookingForOffice',
        description: 'Indicates whether the company is actively looking for office space.',
        type: 'boolean',
        section: 'Office Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'looking_for_office',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Is Sitting On Co-Working Space',
        key: 'isSittingOnCoWorkingSpace',
        description: 'Indicates whether the company currently uses a co-working space.',
        type: 'boolean',
        section: 'Office Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'is_sitting_on_co_working_space',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Lease Expiration Date',
        key: 'leaseExpirationDate',
        description: 'Date when the current office lease expires.',
        type: 'string',
        section: 'Office Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(exports.DateTimeUtcFromString, { onNoneEncoding: null }),
        databaseKey: 'lease_expiration_date',
        databaseType: 'date',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.DateTimeUtcFromDate, { onNoneEncoding: null }),
    },
    {
        title: 'Lease Expiration Date Is Within One Year',
        key: 'leaseExpirationDateIsWithinOneYear',
        description: 'Indicates whether the lease expiration date is within the next year.',
        type: 'boolean',
        section: 'Office Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'lease_expiration_date_is_within_one_year',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'NorNorm Website Visitor',
        key: 'nornormWebsiteVisitor',
        description: 'Indicates whether the company has visited the NorNorm website.',
        type: 'boolean',
        section: 'NorNorm Data',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'nornorm_website_visitor',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'Number of Addresses',
        key: 'numberOfAddresses',
        description: 'Number of different addresses associated with the company.',
        type: 'number',
        section: 'Company Information',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'number_of_addresses',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    // Apollo.io Organization Data
    {
        title: 'Apollo Name',
        key: 'apolloName',
        description: 'Company name from Apollo.io data.',
        type: 'string',
        section: 'Apollo Data',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'apollo_name',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Country',
        key: 'apolloCountry',
        description: 'Company country from Apollo.io data.',
        type: 'string',
        section: 'Apollo Data',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'apollo_country',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Founded Year',
        key: 'apolloFoundedYear',
        description: 'Year the company was founded according to Apollo.io.',
        type: 'number',
        section: 'Apollo Data',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_founded_year',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Publicly Traded Symbol',
        key: 'apolloPubliclyTradedSymbol',
        description: 'Stock symbol if the company is publicly traded according to Apollo.io.',
        type: 'string',
        section: 'Apollo Data',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'apollo_publicly_traded_symbol',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Publicly Traded Exchange',
        key: 'apolloPubliclyTradedExchange',
        description: 'Stock exchange where the company is listed according to Apollo.io.',
        type: 'string',
        section: 'Apollo Data',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'apollo_publicly_traded_exchange',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Latest Funding Stage',
        key: 'apolloLatestFundingStage',
        description: 'Latest funding stage of the company according to Apollo.io.',
        type: 'string',
        section: 'Apollo Data',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'apollo_latest_funding_stage',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Latest Funding Round Date',
        key: 'apolloLatestFundingRoundDate',
        description: 'Date of the latest funding round according to Apollo.io.',
        type: 'string',
        section: 'Apollo Data',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(exports.DateTimeUtcFromString, { onNoneEncoding: null }),
        databaseKey: 'apollo_latest_funding_round_date',
        databaseType: 'date',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.DateTimeUtcFromDate, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Total Funding',
        key: 'apolloTotalFunding',
        description: 'Total funding amount according to Apollo.io.',
        type: 'number',
        section: 'Apollo Data',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_total_funding',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Total Funding Printed',
        key: 'apolloTotalFundingPrinted',
        description: 'Total funding amount as a formatted string according to Apollo.io.',
        type: 'string',
        section: 'Apollo Data',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'apollo_total_funding_printed',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    // Apollo.io Current Headcount
    {
        title: 'Apollo Engineering Head Count Current',
        key: 'apolloEngineeringHeadCountCurrent',
        description: 'Current number of engineering employees according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_engineering_head_count_current',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Sales Head Count Current',
        key: 'apolloSalesHeadCountCurrent',
        description: 'Current number of sales employees according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_sales_head_count_current',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Support Head Count Current',
        key: 'apolloSupportHeadCountCurrent',
        description: 'Current number of support employees according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_support_head_count_current',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Marketing Head Count Current',
        key: 'apolloMarketingHeadCountCurrent',
        description: 'Current number of marketing employees according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_marketing_head_count_current',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Human Resources Head Count Current',
        key: 'apolloHumanResourcesHeadCountCurrent',
        description: 'Current number of human resources employees according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_human_resources_head_count_current',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Education Head Count Current',
        key: 'apolloEducationHeadCountCurrent',
        description: 'Current number of education employees according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_education_head_count_current',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Media and Communication Head Count Current',
        key: 'apolloMediaAndCommunicationHeadCountCurrent',
        description: 'Current number of media and communication employees according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_media_and_communication_head_count_current',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Consulting Head Count Current',
        key: 'apolloConsultingHeadCountCurrent',
        description: 'Current number of consulting employees according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_consulting_head_count_current',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Operations Head Count Current',
        key: 'apolloOperationsHeadCountCurrent',
        description: 'Current number of operations employees according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_operations_head_count_current',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Finance Head Count Current',
        key: 'apolloFinanceHeadCountCurrent',
        description: 'Current number of finance employees according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_finance_head_count_current',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Product Management Head Count Current',
        key: 'apolloProductManagementHeadCountCurrent',
        description: 'Current number of product management employees according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_product_management_head_count_current',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Business Development Head Count Current',
        key: 'apolloBusinessDevelopmentHeadCountCurrent',
        description: 'Current number of business development employees according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_business_development_head_count_current',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Information Technology Head Count Current',
        key: 'apolloInformationTechnologyHeadCountCurrent',
        description: 'Current number of information technology employees according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_information_technology_head_count_current',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Data Science Head Count Current',
        key: 'apolloDataScienceHeadCountCurrent',
        description: 'Current number of data science employees according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_data_science_head_count_current',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Arts and Design Head Count Current',
        key: 'apolloArtsAndDesignHeadCountCurrent',
        description: 'Current number of arts and design employees according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_arts_and_design_head_count_current',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Entrepreneurship Head Count Current',
        key: 'apolloEntrepreneurshipHeadCountCurrent',
        description: 'Current number of entrepreneurship employees according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_entrepreneurship_head_count_current',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Administrative Head Count Current',
        key: 'apolloAdministrativeHeadCountCurrent',
        description: 'Current number of administrative employees according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_administrative_head_count_current',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Legal Head Count Current',
        key: 'apolloLegalHeadCountCurrent',
        description: 'Current number of legal employees according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_legal_head_count_current',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Accounting Head Count Current',
        key: 'apolloAccountingHeadCountCurrent',
        description: 'Current number of accounting employees according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_accounting_head_count_current',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Total Head Count Current',
        key: 'apolloTotalHeadCountCurrent',
        description: 'Current total number of employees according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_total_head_count_current',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    // Apollo.io Historical Headcount (1 month ago)
    {
        title: 'Apollo Engineering Head Count 1 Month Ago',
        key: 'apolloEngineeringHeadCount1MonthAgo',
        description: 'Number of engineering employees 1 month ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_engineering_head_count_1_month_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Sales Head Count 1 Month Ago',
        key: 'apolloSalesHeadCount1MonthAgo',
        description: 'Number of sales employees 1 month ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_sales_head_count_1_month_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Support Head Count 1 Month Ago',
        key: 'apolloSupportHeadCount1MonthAgo',
        description: 'Number of support employees 1 month ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_support_head_count_1_month_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Marketing Head Count 1 Month Ago',
        key: 'apolloMarketingHeadCount1MonthAgo',
        description: 'Number of marketing employees 1 month ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_marketing_head_count_1_month_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Human Resources Head Count 1 Month Ago',
        key: 'apolloHumanResourcesHeadCount1MonthAgo',
        description: 'Number of human resources employees 1 month ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_human_resources_head_count_1_month_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Education Head Count 1 Month Ago',
        key: 'apolloEducationHeadCount1MonthAgo',
        description: 'Number of education employees 1 month ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_education_head_count_1_month_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Media and Communication Head Count 1 Month Ago',
        key: 'apolloMediaAndCommunicationHeadCount1MonthAgo',
        description: 'Number of media and communication employees 1 month ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_media_and_communication_head_count_1_month_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Consulting Head Count 1 Month Ago',
        key: 'apolloConsultingHeadCount1MonthAgo',
        description: 'Number of consulting employees 1 month ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_consulting_head_count_1_month_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Operations Head Count 1 Month Ago',
        key: 'apolloOperationsHeadCount1MonthAgo',
        description: 'Number of operations employees 1 month ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_operations_head_count_1_month_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Finance Head Count 1 Month Ago',
        key: 'apolloFinanceHeadCount1MonthAgo',
        description: 'Number of finance employees 1 month ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_finance_head_count_1_month_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Product Management Head Count 1 Month Ago',
        key: 'apolloProductManagementHeadCount1MonthAgo',
        description: 'Number of product management employees 1 month ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_product_management_head_count_1_month_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Business Development Head Count 1 Month Ago',
        key: 'apolloBusinessDevelopmentHeadCount1MonthAgo',
        description: 'Number of business development employees 1 month ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_business_development_head_count_1_month_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Information Technology Head Count 1 Month Ago',
        key: 'apolloInformationTechnologyHeadCount1MonthAgo',
        description: 'Number of information technology employees 1 month ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_information_technology_head_count_1_month_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Data Science Head Count 1 Month Ago',
        key: 'apolloDataScienceHeadCount1MonthAgo',
        description: 'Number of data science employees 1 month ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_data_science_head_count_1_month_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Arts and Design Head Count 1 Month Ago',
        key: 'apolloArtsAndDesignHeadCount1MonthAgo',
        description: 'Number of arts and design employees 1 month ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_arts_and_design_head_count_1_month_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Entrepreneurship Head Count 1 Month Ago',
        key: 'apolloEntrepreneurshipHeadCount1MonthAgo',
        description: 'Number of entrepreneurship employees 1 month ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_entrepreneurship_head_count_1_month_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Administrative Head Count 1 Month Ago',
        key: 'apolloAdministrativeHeadCount1MonthAgo',
        description: 'Number of administrative employees 1 month ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_administrative_head_count_1_month_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Legal Head Count 1 Month Ago',
        key: 'apolloLegalHeadCount1MonthAgo',
        description: 'Number of legal employees 1 month ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_legal_head_count_1_month_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Accounting Head Count 1 Month Ago',
        key: 'apolloAccountingHeadCount1MonthAgo',
        description: 'Number of accounting employees 1 month ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_accounting_head_count_1_month_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Total Head Count 1 Month Ago',
        key: 'apolloTotalHeadCount1MonthAgo',
        description: 'Total number of employees 1 month ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_total_head_count_1_month_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    // Apollo.io Historical Headcount (3 months ago)
    {
        title: 'Apollo Engineering Head Count 3 Months Ago',
        key: 'apolloEngineeringHeadCount3MonthsAgo',
        description: 'Number of engineering employees 3 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_engineering_head_count_3_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Sales Head Count 3 Months Ago',
        key: 'apolloSalesHeadCount3MonthsAgo',
        description: 'Number of sales employees 3 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_sales_head_count_3_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Support Head Count 3 Months Ago',
        key: 'apolloSupportHeadCount3MonthsAgo',
        description: 'Number of support employees 3 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_support_head_count_3_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Marketing Head Count 3 Months Ago',
        key: 'apolloMarketingHeadCount3MonthsAgo',
        description: 'Number of marketing employees 3 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_marketing_head_count_3_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Human Resources Head Count 3 Months Ago',
        key: 'apolloHumanResourcesHeadCount3MonthsAgo',
        description: 'Number of human resources employees 3 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_human_resources_head_count_3_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Education Head Count 3 Months Ago',
        key: 'apolloEducationHeadCount3MonthsAgo',
        description: 'Number of education employees 3 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_education_head_count_3_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Media and Communication Head Count 3 Months Ago',
        key: 'apolloMediaAndCommunicationHeadCount3MonthsAgo',
        description: 'Number of media and communication employees 3 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_media_and_communication_head_count_3_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Consulting Head Count 3 Months Ago',
        key: 'apolloConsultingHeadCount3MonthsAgo',
        description: 'Number of consulting employees 3 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_consulting_head_count_3_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Operations Head Count 3 Months Ago',
        key: 'apolloOperationsHeadCount3MonthsAgo',
        description: 'Number of operations employees 3 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_operations_head_count_3_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Finance Head Count 3 Months Ago',
        key: 'apolloFinanceHeadCount3MonthsAgo',
        description: 'Number of finance employees 3 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_finance_head_count_3_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Product Management Head Count 3 Months Ago',
        key: 'apolloProductManagementHeadCount3MonthsAgo',
        description: 'Number of product management employees 3 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_product_management_head_count_3_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Business Development Head Count 3 Months Ago',
        key: 'apolloBusinessDevelopmentHeadCount3MonthsAgo',
        description: 'Number of business development employees 3 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_business_development_head_count_3_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Information Technology Head Count 3 Months Ago',
        key: 'apolloInformationTechnologyHeadCount3MonthsAgo',
        description: 'Number of information technology employees 3 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_information_technology_head_count_3_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Data Science Head Count 3 Months Ago',
        key: 'apolloDataScienceHeadCount3MonthsAgo',
        description: 'Number of data science employees 3 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_data_science_head_count_3_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Arts and Design Head Count 3 Months Ago',
        key: 'apolloArtsAndDesignHeadCount3MonthsAgo',
        description: 'Number of arts and design employees 3 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_arts_and_design_head_count_3_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Entrepreneurship Head Count 3 Months Ago',
        key: 'apolloEntrepreneurshipHeadCount3MonthsAgo',
        description: 'Number of entrepreneurship employees 3 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_entrepreneurship_head_count_3_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Administrative Head Count 3 Months Ago',
        key: 'apolloAdministrativeHeadCount3MonthsAgo',
        description: 'Number of administrative employees 3 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_administrative_head_count_3_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Legal Head Count 3 Months Ago',
        key: 'apolloLegalHeadCount3MonthsAgo',
        description: 'Number of legal employees 3 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_legal_head_count_3_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Accounting Head Count 3 Months Ago',
        key: 'apolloAccountingHeadCount3MonthsAgo',
        description: 'Number of accounting employees 3 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_accounting_head_count_3_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Total Head Count 3 Months Ago',
        key: 'apolloTotalHeadCount3MonthsAgo',
        description: 'Total number of employees 3 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_total_head_count_3_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    // Apollo.io Historical Headcount (6 months ago)
    {
        title: 'Apollo Engineering Head Count 6 Months Ago',
        key: 'apolloEngineeringHeadCount6MonthsAgo',
        description: 'Number of engineering employees 6 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_engineering_head_count_6_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Sales Head Count 6 Months Ago',
        key: 'apolloSalesHeadCount6MonthsAgo',
        description: 'Number of sales employees 6 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_sales_head_count_6_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Support Head Count 6 Months Ago',
        key: 'apolloSupportHeadCount6MonthsAgo',
        description: 'Number of support employees 6 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_support_head_count_6_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Marketing Head Count 6 Months Ago',
        key: 'apolloMarketingHeadCount6MonthsAgo',
        description: 'Number of marketing employees 6 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_marketing_head_count_6_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Human Resources Head Count 6 Months Ago',
        key: 'apolloHumanResourcesHeadCount6MonthsAgo',
        description: 'Number of human resources employees 6 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_human_resources_head_count_6_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Education Head Count 6 Months Ago',
        key: 'apolloEducationHeadCount6MonthsAgo',
        description: 'Number of education employees 6 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_education_head_count_6_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Media and Communication Head Count 6 Months Ago',
        key: 'apolloMediaAndCommunicationHeadCount6MonthsAgo',
        description: 'Number of media and communication employees 6 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_media_and_communication_head_count_6_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Consulting Head Count 6 Months Ago',
        key: 'apolloConsultingHeadCount6MonthsAgo',
        description: 'Number of consulting employees 6 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_consulting_head_count_6_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Operations Head Count 6 Months Ago',
        key: 'apolloOperationsHeadCount6MonthsAgo',
        description: 'Number of operations employees 6 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_operations_head_count_6_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Finance Head Count 6 Months Ago',
        key: 'apolloFinanceHeadCount6MonthsAgo',
        description: 'Number of finance employees 6 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_finance_head_count_6_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Product Management Head Count 6 Months Ago',
        key: 'apolloProductManagementHeadCount6MonthsAgo',
        description: 'Number of product management employees 6 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_product_management_head_count_6_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Business Development Head Count 6 Months Ago',
        key: 'apolloBusinessDevelopmentHeadCount6MonthsAgo',
        description: 'Number of business development employees 6 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_business_development_head_count_6_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Information Technology Head Count 6 Months Ago',
        key: 'apolloInformationTechnologyHeadCount6MonthsAgo',
        description: 'Number of information technology employees 6 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_information_technology_head_count_6_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Data Science Head Count 6 Months Ago',
        key: 'apolloDataScienceHeadCount6MonthsAgo',
        description: 'Number of data science employees 6 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_data_science_head_count_6_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Arts and Design Head Count 6 Months Ago',
        key: 'apolloArtsAndDesignHeadCount6MonthsAgo',
        description: 'Number of arts and design employees 6 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_arts_and_design_head_count_6_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Entrepreneurship Head Count 6 Months Ago',
        key: 'apolloEntrepreneurshipHeadCount6MonthsAgo',
        description: 'Number of entrepreneurship employees 6 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_entrepreneurship_head_count_6_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Administrative Head Count 6 Months Ago',
        key: 'apolloAdministrativeHeadCount6MonthsAgo',
        description: 'Number of administrative employees 6 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_administrative_head_count_6_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Legal Head Count 6 Months Ago',
        key: 'apolloLegalHeadCount6MonthsAgo',
        description: 'Number of legal employees 6 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_legal_head_count_6_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Accounting Head Count 6 Months Ago',
        key: 'apolloAccountingHeadCount6MonthsAgo',
        description: 'Number of accounting employees 6 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_accounting_head_count_6_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Total Head Count 6 Months Ago',
        key: 'apolloTotalHeadCount6MonthsAgo',
        description: 'Total number of employees 6 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_total_head_count_6_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    // Apollo.io Historical Headcount (9 months ago)
    {
        title: 'Apollo Engineering Head Count 9 Months Ago',
        key: 'apolloEngineeringHeadCount9MonthsAgo',
        description: 'Number of engineering employees 9 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_engineering_head_count_9_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Sales Head Count 9 Months Ago',
        key: 'apolloSalesHeadCount9MonthsAgo',
        description: 'Number of sales employees 9 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_sales_head_count_9_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Support Head Count 9 Months Ago',
        key: 'apolloSupportHeadCount9MonthsAgo',
        description: 'Number of support employees 9 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_support_head_count_9_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Marketing Head Count 9 Months Ago',
        key: 'apolloMarketingHeadCount9MonthsAgo',
        description: 'Number of marketing employees 9 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_marketing_head_count_9_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Human Resources Head Count 9 Months Ago',
        key: 'apolloHumanResourcesHeadCount9MonthsAgo',
        description: 'Number of human resources employees 9 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_human_resources_head_count_9_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Education Head Count 9 Months Ago',
        key: 'apolloEducationHeadCount9MonthsAgo',
        description: 'Number of education employees 9 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_education_head_count_9_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Media and Communication Head Count 9 Months Ago',
        key: 'apolloMediaAndCommunicationHeadCount9MonthsAgo',
        description: 'Number of media and communication employees 9 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_media_and_communication_head_count_9_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Consulting Head Count 9 Months Ago',
        key: 'apolloConsultingHeadCount9MonthsAgo',
        description: 'Number of consulting employees 9 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_consulting_head_count_9_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Operations Head Count 9 Months Ago',
        key: 'apolloOperationsHeadCount9MonthsAgo',
        description: 'Number of operations employees 9 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_operations_head_count_9_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Finance Head Count 9 Months Ago',
        key: 'apolloFinanceHeadCount9MonthsAgo',
        description: 'Number of finance employees 9 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_finance_head_count_9_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Product Management Head Count 9 Months Ago',
        key: 'apolloProductManagementHeadCount9MonthsAgo',
        description: 'Number of product management employees 9 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_product_management_head_count_9_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Business Development Head Count 9 Months Ago',
        key: 'apolloBusinessDevelopmentHeadCount9MonthsAgo',
        description: 'Number of business development employees 9 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_business_development_head_count_9_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Information Technology Head Count 9 Months Ago',
        key: 'apolloInformationTechnologyHeadCount9MonthsAgo',
        description: 'Number of information technology employees 9 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_information_technology_head_count_9_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Data Science Head Count 9 Months Ago',
        key: 'apolloDataScienceHeadCount9MonthsAgo',
        description: 'Number of data science employees 9 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_data_science_head_count_9_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Arts and Design Head Count 9 Months Ago',
        key: 'apolloArtsAndDesignHeadCount9MonthsAgo',
        description: 'Number of arts and design employees 9 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_arts_and_design_head_count_9_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Entrepreneurship Head Count 9 Months Ago',
        key: 'apolloEntrepreneurshipHeadCount9MonthsAgo',
        description: 'Number of entrepreneurship employees 9 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_entrepreneurship_head_count_9_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Administrative Head Count 9 Months Ago',
        key: 'apolloAdministrativeHeadCount9MonthsAgo',
        description: 'Number of administrative employees 9 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_administrative_head_count_9_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Legal Head Count 9 Months Ago',
        key: 'apolloLegalHeadCount9MonthsAgo',
        description: 'Number of legal employees 9 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_legal_head_count_9_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Accounting Head Count 9 Months Ago',
        key: 'apolloAccountingHeadCount9MonthsAgo',
        description: 'Number of accounting employees 9 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_accounting_head_count_9_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Total Head Count 9 Months Ago',
        key: 'apolloTotalHeadCount9MonthsAgo',
        description: 'Total number of employees 9 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_total_head_count_9_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    // Apollo.io Historical Headcount (12 months ago)
    {
        title: 'Apollo Engineering Head Count 12 Months Ago',
        key: 'apolloEngineeringHeadCount12MonthsAgo',
        description: 'Number of engineering employees 12 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_engineering_head_count_12_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Sales Head Count 12 Months Ago',
        key: 'apolloSalesHeadCount12MonthsAgo',
        description: 'Number of sales employees 12 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_sales_head_count_12_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Support Head Count 12 Months Ago',
        key: 'apolloSupportHeadCount12MonthsAgo',
        description: 'Number of support employees 12 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_support_head_count_12_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Marketing Head Count 12 Months Ago',
        key: 'apolloMarketingHeadCount12MonthsAgo',
        description: 'Number of marketing employees 12 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_marketing_head_count_12_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Human Resources Head Count 12 Months Ago',
        key: 'apolloHumanResourcesHeadCount12MonthsAgo',
        description: 'Number of human resources employees 12 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_human_resources_head_count_12_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Education Head Count 12 Months Ago',
        key: 'apolloEducationHeadCount12MonthsAgo',
        description: 'Number of education employees 12 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_education_head_count_12_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Media and Communication Head Count 12 Months Ago',
        key: 'apolloMediaAndCommunicationHeadCount12MonthsAgo',
        description: 'Number of media and communication employees 12 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_media_and_communication_head_count_12_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Consulting Head Count 12 Months Ago',
        key: 'apolloConsultingHeadCount12MonthsAgo',
        description: 'Number of consulting employees 12 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_consulting_head_count_12_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Operations Head Count 12 Months Ago',
        key: 'apolloOperationsHeadCount12MonthsAgo',
        description: 'Number of operations employees 12 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_operations_head_count_12_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Finance Head Count 12 Months Ago',
        key: 'apolloFinanceHeadCount12MonthsAgo',
        description: 'Number of finance employees 12 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_finance_head_count_12_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Product Management Head Count 12 Months Ago',
        key: 'apolloProductManagementHeadCount12MonthsAgo',
        description: 'Number of product management employees 12 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_product_management_head_count_12_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Business Development Head Count 12 Months Ago',
        key: 'apolloBusinessDevelopmentHeadCount12MonthsAgo',
        description: 'Number of business development employees 12 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_business_development_head_count_12_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Information Technology Head Count 12 Months Ago',
        key: 'apolloInformationTechnologyHeadCount12MonthsAgo',
        description: 'Number of information technology employees 12 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_information_technology_head_count_12_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Data Science Head Count 12 Months Ago',
        key: 'apolloDataScienceHeadCount12MonthsAgo',
        description: 'Number of data science employees 12 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_data_science_head_count_12_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Arts and Design Head Count 12 Months Ago',
        key: 'apolloArtsAndDesignHeadCount12MonthsAgo',
        description: 'Number of arts and design employees 12 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_arts_and_design_head_count_12_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Entrepreneurship Head Count 12 Months Ago',
        key: 'apolloEntrepreneurshipHeadCount12MonthsAgo',
        description: 'Number of entrepreneurship employees 12 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_entrepreneurship_head_count_12_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Administrative Head Count 12 Months Ago',
        key: 'apolloAdministrativeHeadCount12MonthsAgo',
        description: 'Number of administrative employees 12 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_administrative_head_count_12_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Legal Head Count 12 Months Ago',
        key: 'apolloLegalHeadCount12MonthsAgo',
        description: 'Number of legal employees 12 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_legal_head_count_12_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Accounting Head Count 12 Months Ago',
        key: 'apolloAccountingHeadCount12MonthsAgo',
        description: 'Number of accounting employees 12 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_accounting_head_count_12_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Total Head Count 12 Months Ago',
        key: 'apolloTotalHeadCount12MonthsAgo',
        description: 'Total number of employees 12 months ago according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_total_head_count_12_months_ago',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    // Apollo.io Headcount Growth (1 month)
    {
        title: 'Apollo Engineering Head Count Growth 1 Month',
        key: 'apolloEngineeringHeadCountGrowth1Month',
        description: 'Growth in engineering employees over 1 month according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_engineering_head_count_growth_1_month',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Sales Head Count Growth 1 Month',
        key: 'apolloSalesHeadCountGrowth1Month',
        description: 'Growth in sales employees over 1 month according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_sales_head_count_growth_1_month',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Support Head Count Growth 1 Month',
        key: 'apolloSupportHeadCountGrowth1Month',
        description: 'Growth in support employees over 1 month according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_support_head_count_growth_1_month',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Marketing Head Count Growth 1 Month',
        key: 'apolloMarketingHeadCountGrowth1Month',
        description: 'Growth in marketing employees over 1 month according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_marketing_head_count_growth_1_month',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Human Resources Head Count Growth 1 Month',
        key: 'apolloHumanResourcesHeadCountGrowth1Month',
        description: 'Growth in human resources employees over 1 month according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_human_resources_head_count_growth_1_month',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Education Head Count Growth 1 Month',
        key: 'apolloEducationHeadCountGrowth1Month',
        description: 'Growth in education employees over 1 month according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_education_head_count_growth_1_month',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Media and Communication Head Count Growth 1 Month',
        key: 'apolloMediaAndCommunicationHeadCountGrowth1Month',
        description: 'Growth in media and communication employees over 1 month according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_media_and_communication_head_count_growth_1_month',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Consulting Head Count Growth 1 Month',
        key: 'apolloConsultingHeadCountGrowth1Month',
        description: 'Growth in consulting employees over 1 month according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_consulting_head_count_growth_1_month',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Operations Head Count Growth 1 Month',
        key: 'apolloOperationsHeadCountGrowth1Month',
        description: 'Growth in operations employees over 1 month according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_operations_head_count_growth_1_month',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Finance Head Count Growth 1 Month',
        key: 'apolloFinanceHeadCountGrowth1Month',
        description: 'Growth in finance employees over 1 month according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_finance_head_count_growth_1_month',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Product Management Head Count Growth 1 Month',
        key: 'apolloProductManagementHeadCountGrowth1Month',
        description: 'Growth in product management employees over 1 month according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_product_management_head_count_growth_1_month',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Business Development Head Count Growth 1 Month',
        key: 'apolloBusinessDevelopmentHeadCountGrowth1Month',
        description: 'Growth in business development employees over 1 month according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_business_development_head_count_growth_1_month',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Information Technology Head Count Growth 1 Month',
        key: 'apolloInformationTechnologyHeadCountGrowth1Month',
        description: 'Growth in information technology employees over 1 month according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_information_technology_head_count_growth_1_month',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Data Science Head Count Growth 1 Month',
        key: 'apolloDataScienceHeadCountGrowth1Month',
        description: 'Growth in data science employees over 1 month according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_data_science_head_count_growth_1_month',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Arts and Design Head Count Growth 1 Month',
        key: 'apolloArtsAndDesignHeadCountGrowth1Month',
        description: 'Growth in arts and design employees over 1 month according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_arts_and_design_head_count_growth_1_month',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Entrepreneurship Head Count Growth 1 Month',
        key: 'apolloEntrepreneurshipHeadCountGrowth1Month',
        description: 'Growth in entrepreneurship employees over 1 month according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_entrepreneurship_head_count_growth_1_month',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Administrative Head Count Growth 1 Month',
        key: 'apolloAdministrativeHeadCountGrowth1Month',
        description: 'Growth in administrative employees over 1 month according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_administrative_head_count_growth_1_month',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Legal Head Count Growth 1 Month',
        key: 'apolloLegalHeadCountGrowth1Month',
        description: 'Growth in legal employees over 1 month according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_legal_head_count_growth_1_month',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Accounting Head Count Growth 1 Month',
        key: 'apolloAccountingHeadCountGrowth1Month',
        description: 'Growth in accounting employees over 1 month according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_accounting_head_count_growth_1_month',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Total Head Count Growth 1 Month',
        key: 'apolloTotalHeadCountGrowth1Month',
        description: 'Growth in total employees over 1 month according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_total_head_count_growth_1_month',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    // Apollo Growth Fields - 3 months
    {
        title: 'Apollo Engineering Head Count Growth 3 Months',
        key: 'apolloEngineeringHeadCountGrowth3Months',
        description: 'Growth in engineering employees over 3 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_engineering_head_count_growth_3_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Sales Head Count Growth 3 Months',
        key: 'apolloSalesHeadCountGrowth3Months',
        description: 'Growth in sales employees over 3 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_sales_head_count_growth_3_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Support Head Count Growth 3 Months',
        key: 'apolloSupportHeadCountGrowth3Months',
        description: 'Growth in support employees over 3 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_support_head_count_growth_3_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Marketing Head Count Growth 3 Months',
        key: 'apolloMarketingHeadCountGrowth3Months',
        description: 'Growth in marketing employees over 3 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_marketing_head_count_growth_3_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Human Resources Head Count Growth 3 Months',
        key: 'apolloHumanResourcesHeadCountGrowth3Months',
        description: 'Growth in human resources employees over 3 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_human_resources_head_count_growth_3_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Education Head Count Growth 3 Months',
        key: 'apolloEducationHeadCountGrowth3Months',
        description: 'Growth in education employees over 3 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_education_head_count_growth_3_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Media and Communication Head Count Growth 3 Months',
        key: 'apolloMediaAndCommunicationHeadCountGrowth3Months',
        description: 'Growth in media and communication employees over 3 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_media_and_communication_head_count_growth_3_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Consulting Head Count Growth 3 Months',
        key: 'apolloConsultingHeadCountGrowth3Months',
        description: 'Growth in consulting employees over 3 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_consulting_head_count_growth_3_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Operations Head Count Growth 3 Months',
        key: 'apolloOperationsHeadCountGrowth3Months',
        description: 'Growth in operations employees over 3 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_operations_head_count_growth_3_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Finance Head Count Growth 3 Months',
        key: 'apolloFinanceHeadCountGrowth3Months',
        description: 'Growth in finance employees over 3 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_finance_head_count_growth_3_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Product Management Head Count Growth 3 Months',
        key: 'apolloProductManagementHeadCountGrowth3Months',
        description: 'Growth in product management employees over 3 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_product_management_head_count_growth_3_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Business Development Head Count Growth 3 Months',
        key: 'apolloBusinessDevelopmentHeadCountGrowth3Months',
        description: 'Growth in business development employees over 3 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_business_development_head_count_growth_3_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Information Technology Head Count Growth 3 Months',
        key: 'apolloInformationTechnologyHeadCountGrowth3Months',
        description: 'Growth in information technology employees over 3 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_information_technology_head_count_growth_3_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Data Science Head Count Growth 3 Months',
        key: 'apolloDataScienceHeadCountGrowth3Months',
        description: 'Growth in data science employees over 3 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_data_science_head_count_growth_3_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Arts and Design Head Count Growth 3 Months',
        key: 'apolloArtsAndDesignHeadCountGrowth3Months',
        description: 'Growth in arts and design employees over 3 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_arts_and_design_head_count_growth_3_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Entrepreneurship Head Count Growth 3 Months',
        key: 'apolloEntrepreneurshipHeadCountGrowth3Months',
        description: 'Growth in entrepreneurship employees over 3 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_entrepreneurship_head_count_growth_3_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Administrative Head Count Growth 3 Months',
        key: 'apolloAdministrativeHeadCountGrowth3Months',
        description: 'Growth in administrative employees over 3 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_administrative_head_count_growth_3_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Legal Head Count Growth 3 Months',
        key: 'apolloLegalHeadCountGrowth3Months',
        description: 'Growth in legal employees over 3 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_legal_head_count_growth_3_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Accounting Head Count Growth 3 Months',
        key: 'apolloAccountingHeadCountGrowth3Months',
        description: 'Growth in accounting employees over 3 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_accounting_head_count_growth_3_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Total Head Count Growth 3 Months',
        key: 'apolloTotalHeadCountGrowth3Months',
        description: 'Growth in total employees over 3 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_total_head_count_growth_3_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    // Apollo Growth Fields - 6 months
    {
        title: 'Apollo Engineering Head Count Growth 6 Months',
        key: 'apolloEngineeringHeadCountGrowth6Months',
        description: 'Growth in engineering employees over 6 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_engineering_head_count_growth_6_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Sales Head Count Growth 6 Months',
        key: 'apolloSalesHeadCountGrowth6Months',
        description: 'Growth in sales employees over 6 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_sales_head_count_growth_6_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Support Head Count Growth 6 Months',
        key: 'apolloSupportHeadCountGrowth6Months',
        description: 'Growth in support employees over 6 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_support_head_count_growth_6_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Marketing Head Count Growth 6 Months',
        key: 'apolloMarketingHeadCountGrowth6Months',
        description: 'Growth in marketing employees over 6 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_marketing_head_count_growth_6_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Human Resources Head Count Growth 6 Months',
        key: 'apolloHumanResourcesHeadCountGrowth6Months',
        description: 'Growth in human resources employees over 6 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_human_resources_head_count_growth_6_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Education Head Count Growth 6 Months',
        key: 'apolloEducationHeadCountGrowth6Months',
        description: 'Growth in education employees over 6 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_education_head_count_growth_6_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Media and Communication Head Count Growth 6 Months',
        key: 'apolloMediaAndCommunicationHeadCountGrowth6Months',
        description: 'Growth in media and communication employees over 6 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_media_and_communication_head_count_growth_6_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Consulting Head Count Growth 6 Months',
        key: 'apolloConsultingHeadCountGrowth6Months',
        description: 'Growth in consulting employees over 6 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_consulting_head_count_growth_6_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Operations Head Count Growth 6 Months',
        key: 'apolloOperationsHeadCountGrowth6Months',
        description: 'Growth in operations employees over 6 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_operations_head_count_growth_6_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Finance Head Count Growth 6 Months',
        key: 'apolloFinanceHeadCountGrowth6Months',
        description: 'Growth in finance employees over 6 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_finance_head_count_growth_6_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Product Management Head Count Growth 6 Months',
        key: 'apolloProductManagementHeadCountGrowth6Months',
        description: 'Growth in product management employees over 6 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_product_management_head_count_growth_6_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Business Development Head Count Growth 6 Months',
        key: 'apolloBusinessDevelopmentHeadCountGrowth6Months',
        description: 'Growth in business development employees over 6 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_business_development_head_count_growth_6_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Information Technology Head Count Growth 6 Months',
        key: 'apolloInformationTechnologyHeadCountGrowth6Months',
        description: 'Growth in information technology employees over 6 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_information_technology_head_count_growth_6_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Data Science Head Count Growth 6 Months',
        key: 'apolloDataScienceHeadCountGrowth6Months',
        description: 'Growth in data science employees over 6 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_data_science_head_count_growth_6_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Arts and Design Head Count Growth 6 Months',
        key: 'apolloArtsAndDesignHeadCountGrowth6Months',
        description: 'Growth in arts and design employees over 6 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_arts_and_design_head_count_growth_6_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Entrepreneurship Head Count Growth 6 Months',
        key: 'apolloEntrepreneurshipHeadCountGrowth6Months',
        description: 'Growth in entrepreneurship employees over 6 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_entrepreneurship_head_count_growth_6_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Administrative Head Count Growth 6 Months',
        key: 'apolloAdministrativeHeadCountGrowth6Months',
        description: 'Growth in administrative employees over 6 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_administrative_head_count_growth_6_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Legal Head Count Growth 6 Months',
        key: 'apolloLegalHeadCountGrowth6Months',
        description: 'Growth in legal employees over 6 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_legal_head_count_growth_6_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Accounting Head Count Growth 6 Months',
        key: 'apolloAccountingHeadCountGrowth6Months',
        description: 'Growth in accounting employees over 6 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_accounting_head_count_growth_6_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Total Head Count Growth 6 Months',
        key: 'apolloTotalHeadCountGrowth6Months',
        description: 'Growth in total employees over 6 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_total_head_count_growth_6_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    // Apollo Growth Fields - 9 months
    {
        title: 'Apollo Engineering Head Count Growth 9 Months',
        key: 'apolloEngineeringHeadCountGrowth9Months',
        description: 'Growth in engineering employees over 9 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_engineering_head_count_growth_9_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Sales Head Count Growth 9 Months',
        key: 'apolloSalesHeadCountGrowth9Months',
        description: 'Growth in sales employees over 9 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_sales_head_count_growth_9_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Support Head Count Growth 9 Months',
        key: 'apolloSupportHeadCountGrowth9Months',
        description: 'Growth in support employees over 9 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_support_head_count_growth_9_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Marketing Head Count Growth 9 Months',
        key: 'apolloMarketingHeadCountGrowth9Months',
        description: 'Growth in marketing employees over 9 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_marketing_head_count_growth_9_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Human Resources Head Count Growth 9 Months',
        key: 'apolloHumanResourcesHeadCountGrowth9Months',
        description: 'Growth in human resources employees over 9 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_human_resources_head_count_growth_9_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Education Head Count Growth 9 Months',
        key: 'apolloEducationHeadCountGrowth9Months',
        description: 'Growth in education employees over 9 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_education_head_count_growth_9_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Media and Communication Head Count Growth 9 Months',
        key: 'apolloMediaAndCommunicationHeadCountGrowth9Months',
        description: 'Growth in media and communication employees over 9 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_media_and_communication_head_count_growth_9_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Consulting Head Count Growth 9 Months',
        key: 'apolloConsultingHeadCountGrowth9Months',
        description: 'Growth in consulting employees over 9 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_consulting_head_count_growth_9_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Operations Head Count Growth 9 Months',
        key: 'apolloOperationsHeadCountGrowth9Months',
        description: 'Growth in operations employees over 9 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_operations_head_count_growth_9_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Finance Head Count Growth 9 Months',
        key: 'apolloFinanceHeadCountGrowth9Months',
        description: 'Growth in finance employees over 9 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_finance_head_count_growth_9_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Product Management Head Count Growth 9 Months',
        key: 'apolloProductManagementHeadCountGrowth9Months',
        description: 'Growth in product management employees over 9 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_product_management_head_count_growth_9_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Business Development Head Count Growth 9 Months',
        key: 'apolloBusinessDevelopmentHeadCountGrowth9Months',
        description: 'Growth in business development employees over 9 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_business_development_head_count_growth_9_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Information Technology Head Count Growth 9 Months',
        key: 'apolloInformationTechnologyHeadCountGrowth9Months',
        description: 'Growth in information technology employees over 9 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_information_technology_head_count_growth_9_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Data Science Head Count Growth 9 Months',
        key: 'apolloDataScienceHeadCountGrowth9Months',
        description: 'Growth in data science employees over 9 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_data_science_head_count_growth_9_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Arts and Design Head Count Growth 9 Months',
        key: 'apolloArtsAndDesignHeadCountGrowth9Months',
        description: 'Growth in arts and design employees over 9 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_arts_and_design_head_count_growth_9_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Entrepreneurship Head Count Growth 9 Months',
        key: 'apolloEntrepreneurshipHeadCountGrowth9Months',
        description: 'Growth in entrepreneurship employees over 9 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_entrepreneurship_head_count_growth_9_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Administrative Head Count Growth 9 Months',
        key: 'apolloAdministrativeHeadCountGrowth9Months',
        description: 'Growth in administrative employees over 9 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_administrative_head_count_growth_9_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Legal Head Count Growth 9 Months',
        key: 'apolloLegalHeadCountGrowth9Months',
        description: 'Growth in legal employees over 9 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_legal_head_count_growth_9_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Accounting Head Count Growth 9 Months',
        key: 'apolloAccountingHeadCountGrowth9Months',
        description: 'Growth in accounting employees over 9 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_accounting_head_count_growth_9_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Total Head Count Growth 9 Months',
        key: 'apolloTotalHeadCountGrowth9Months',
        description: 'Growth in total employees over 9 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_total_head_count_growth_9_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    // Apollo Growth Fields - 12 months
    {
        title: 'Apollo Engineering Head Count Growth 12 Months',
        key: 'apolloEngineeringHeadCountGrowth12Months',
        description: 'Growth in engineering employees over 12 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_engineering_head_count_growth_12_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Sales Head Count Growth 12 Months',
        key: 'apolloSalesHeadCountGrowth12Months',
        description: 'Growth in sales employees over 12 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_sales_head_count_growth_12_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Support Head Count Growth 12 Months',
        key: 'apolloSupportHeadCountGrowth12Months',
        description: 'Growth in support employees over 12 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_support_head_count_growth_12_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Marketing Head Count Growth 12 Months',
        key: 'apolloMarketingHeadCountGrowth12Months',
        description: 'Growth in marketing employees over 12 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_marketing_head_count_growth_12_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Human Resources Head Count Growth 12 Months',
        key: 'apolloHumanResourcesHeadCountGrowth12Months',
        description: 'Growth in human resources employees over 12 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_human_resources_head_count_growth_12_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Education Head Count Growth 12 Months',
        key: 'apolloEducationHeadCountGrowth12Months',
        description: 'Growth in education employees over 12 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_education_head_count_growth_12_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Media and Communication Head Count Growth 12 Months',
        key: 'apolloMediaAndCommunicationHeadCountGrowth12Months',
        description: 'Growth in media and communication employees over 12 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_media_and_communication_head_count_growth_12_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Consulting Head Count Growth 12 Months',
        key: 'apolloConsultingHeadCountGrowth12Months',
        description: 'Growth in consulting employees over 12 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_consulting_head_count_growth_12_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Operations Head Count Growth 12 Months',
        key: 'apolloOperationsHeadCountGrowth12Months',
        description: 'Growth in operations employees over 12 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_operations_head_count_growth_12_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Finance Head Count Growth 12 Months',
        key: 'apolloFinanceHeadCountGrowth12Months',
        description: 'Growth in finance employees over 12 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_finance_head_count_growth_12_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Product Management Head Count Growth 12 Months',
        key: 'apolloProductManagementHeadCountGrowth12Months',
        description: 'Growth in product management employees over 12 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_product_management_head_count_growth_12_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Business Development Head Count Growth 12 Months',
        key: 'apolloBusinessDevelopmentHeadCountGrowth12Months',
        description: 'Growth in business development employees over 12 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_business_development_head_count_growth_12_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Information Technology Head Count Growth 12 Months',
        key: 'apolloInformationTechnologyHeadCountGrowth12Months',
        description: 'Growth in information technology employees over 12 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_information_technology_head_count_growth_12_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Data Science Head Count Growth 12 Months',
        key: 'apolloDataScienceHeadCountGrowth12Months',
        description: 'Growth in data science employees over 12 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_data_science_head_count_growth_12_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Arts and Design Head Count Growth 12 Months',
        key: 'apolloArtsAndDesignHeadCountGrowth12Months',
        description: 'Growth in arts and design employees over 12 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_arts_and_design_head_count_growth_12_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Entrepreneurship Head Count Growth 12 Months',
        key: 'apolloEntrepreneurshipHeadCountGrowth12Months',
        description: 'Growth in entrepreneurship employees over 12 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_entrepreneurship_head_count_growth_12_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Administrative Head Count Growth 12 Months',
        key: 'apolloAdministrativeHeadCountGrowth12Months',
        description: 'Growth in administrative employees over 12 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_administrative_head_count_growth_12_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Legal Head Count Growth 12 Months',
        key: 'apolloLegalHeadCountGrowth12Months',
        description: 'Growth in legal employees over 12 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_legal_head_count_growth_12_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Accounting Head Count Growth 12 Months',
        key: 'apolloAccountingHeadCountGrowth12Months',
        description: 'Growth in accounting employees over 12 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_accounting_head_count_growth_12_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'Apollo Total Head Count Growth 12 Months',
        key: 'apolloTotalHeadCountGrowth12Months',
        description: 'Growth in total employees over 12 months according to Apollo.io.',
        type: 'number',
        section: 'Apollo Headcount',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'apollo_total_head_count_growth_12_months',
        databaseType: 'numeric',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    // PRV Applicant Aggregates
    {
        title: 'PRV Applicant Has Trademark',
        key: 'prvApplicantHasTrademark',
        description: 'Whether the applicant has any PRV trademarks.',
        type: 'boolean',
        section: 'Trademarks',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'prv_applicant_has_trademark',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'PRV Applicant Trademark Count (Total)',
        key: 'prvApplicantTrademarkCountTotal',
        description: 'Total number of PRV trademarks for the applicant.',
        type: 'number',
        section: 'Trademarks',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'prv_applicant_trademark_count_total',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'PRV Applicant Trademark Count (Active)',
        key: 'prvApplicantTrademarkCountActive',
        description: 'Number of active PRV trademarks for the applicant.',
        type: 'number',
        section: 'Trademarks',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'prv_applicant_trademark_count_active',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'PRV Applicant Trademarks Last 3 Months',
        key: 'prvApplicantTrademarksLast3mCount',
        description: 'Number of PRV trademark applications from the last 3 months.',
        type: 'number',
        section: 'Trademarks',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'prv_applicant_trademarks_last_3m_count',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'PRV Applicant Trademarks Last 12 Months',
        key: 'prvApplicantTrademarksLast12mCount',
        description: 'Number of PRV trademark applications from the last 12 months.',
        type: 'number',
        section: 'Trademarks',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'prv_applicant_trademarks_last_12m_count',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'PRV Applicant Applied Last 3 Months',
        key: 'prvApplicantAppliedLast3m',
        description: 'Whether the applicant has applied for any PRV trademarks in the last 3 months.',
        type: 'boolean',
        section: 'Trademarks',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'prv_applicant_applied_last_3m',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'PRV Applicant Applied Last 12 Months',
        key: 'prvApplicantAppliedLast12m',
        description: 'Whether the applicant has applied for any PRV trademarks in the last 12 months.',
        type: 'boolean',
        section: 'Trademarks',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
        databaseKey: 'prv_applicant_applied_last_12m',
        databaseType: 'boolean',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Boolean, { onNoneEncoding: null }),
    },
    {
        title: 'PRV Applicant Latest Application Date',
        key: 'prvApplicantLatestApplicationDate',
        description: 'Latest PRV trademark application date for the applicant.',
        type: 'string',
        section: 'Trademarks',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(exports.DateTimeUtcFromString, { onNoneEncoding: null }),
        databaseKey: 'prv_applicant_latest_application_date',
        databaseType: 'date',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.DateTimeUtcFromDate, { onNoneEncoding: null }),
    },
    {
        title: 'PRV Applicant Latest Status',
        key: 'prvApplicantLatestStatus',
        description: 'Latest PRV trademark status for the applicant.',
        type: 'string',
        section: 'Trademarks',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'prv_applicant_latest_status',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'PRV Applicant Nice Classes',
        key: 'prvApplicantNiceClasses',
        description: 'Array of Nice classification class numbers for applicant trademarks.',
        type: 'array',
        section: 'Trademarks',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.Number), { onNoneEncoding: null }),
        databaseKey: 'prv_applicant_nice_classes',
        databaseType: 'numeric-array',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.Number), { onNoneEncoding: null }),
    },
    {
        title: 'PRV Applicant Nice Class Count',
        key: 'prvApplicantNiceClassCount',
        description: 'Number of distinct Nice classes across applicant trademarks.',
        type: 'number',
        section: 'Trademarks',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'prv_applicant_nice_class_count',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'PRV Applicant Top Marks',
        key: 'prvApplicantTopMarks',
        description: 'Top recent verbal marks for the applicant (up to 3).',
        type: 'array',
        section: 'Trademarks',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
        databaseKey: 'prv_applicant_top_marks',
        databaseType: 'string-array',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Array(effect_1.Schema.String), { onNoneEncoding: null }),
    },
    {
        title: 'PRV Applicant Next Renewal Date',
        key: 'prvApplicantNextRenewalDate',
        description: 'The next upcoming renewal date among applicant trademarks.',
        type: 'string',
        section: 'Trademarks',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(exports.DateTimeUtcFromString, { onNoneEncoding: null }),
        databaseKey: 'prv_applicant_next_renewal_date',
        databaseType: 'date',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.DateTimeUtcFromDate, { onNoneEncoding: null }),
    },
    {
        title: 'PRV Applicant Mapped Count',
        key: 'prvApplicantMappedCount',
        description: 'Number of applicant mappings to companies.',
        type: 'number',
        section: 'Trademarks',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.Number, { onNoneEncoding: null }),
        databaseKey: 'prv_applicant_mapped_count',
        databaseType: 'integer',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }),
    },
    {
        title: 'PRV Applicant Mapping Method',
        key: 'prvApplicantMappingMethod',
        description: 'Primary method used to map applicant to company (reference or name).',
        type: 'string',
        section: 'Trademarks',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
        databaseKey: 'prv_applicant_mapping_method',
        databaseType: 'string',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.String, { onNoneEncoding: null }),
    },
    {
        title: 'PRV Applicant Last Mapped At',
        key: 'prvApplicantLastMappedAt',
        description: 'Timestamp when the applicant-company mapping was last updated.',
        type: 'string',
        section: 'Trademarks',
        nullable: true,
        schema: effect_1.Schema.OptionFromOptionalNullOr(exports.DateTimeUtcFromString, { onNoneEncoding: null }),
        databaseKey: 'prv_applicant_last_mapped_at',
        databaseType: 'date',
        databaseSchema: effect_1.Schema.OptionFromOptionalNullOr(effect_1.Schema.DateTimeUtcFromDate, { onNoneEncoding: null }),
    },
];
exports.masterDataKeys = Object.freeze(effect_1.Array.map(exports.effectDataFields, (field) => field.key));
exports.masterDataDBKeys = Object.freeze(effect_1.Array.map(exports.effectDataFields, (field) => field.databaseKey));
exports.MasterDataFields = effect_1.Array.reduce(exports.effectDataFields, {}, (acc, curr) => {
    return {
        ...acc,
        [curr.key]: curr,
    };
});
const definitions = exports.effectDataFields;
const annotatedField = (schema, field) => schema.annotate({ title: field.title, description: field.description });
const scoreKey = (key) => `${key}Score`;
const scoreField = (field) => effect_1.Schema.OptionFromOptionalNullOr(schemas_1.EnsuredNumber, { onNoneEncoding: null }).annotate({
    title: `${field.title} Score`,
    description: `Score for ${field.description}`,
});
const fieldsOf = (schemaOf) => Object.fromEntries(definitions.map((field) => [field.key, annotatedField(schemaOf(field), field)]));
const fieldsWithScoresOf = (schemaOf) => Object.fromEntries(definitions.flatMap((field) => [
    [field.key, annotatedField(schemaOf(field), field)],
    [scoreKey(field.key), scoreField(field)],
]));
/** Record key -> database column, including the `<column>_score` column of each field. */
const databaseKeys = Object.fromEntries(definitions.map((field) => [field.key, field.databaseKey]));
const databaseKeysWithScores = Object.fromEntries(definitions.flatMap((field) => [
    [field.key, field.databaseKey],
    [scoreKey(field.key), `${field.databaseKey}_score`],
]));
const optionalFields = (fields) => Object.fromEntries(Object.entries(fields).map(([key, schema]) => [key, effect_1.Schema.optional(schema)]));
const score = schemas_1.EnsuredNumber.pipe(effect_1.Schema.withDecodingDefaultType(effect_1.Effect.sync(() => 0)), effect_1.Schema.withConstructorDefault(effect_1.Effect.sync(() => 0)));
const recordFields = fieldsOf((field) => field.schema);
const databaseFields = fieldsOf((field) => field.databaseSchema);
const MasterDataDatabaseSchema = effect_1.Schema.Struct(databaseFields).pipe(effect_1.Schema.encodeKeys(databaseKeys));
exports.MasterDataDatabaseSchemaWithScore = effect_1.Schema.Struct({
    ...fieldsWithScoresOf((field) => field.databaseSchema),
    score,
}).pipe(effect_1.Schema.encodeKeys(databaseKeysWithScores));
exports.MasterDataSchemaWithScore = effect_1.Schema.Struct({
    ...fieldsWithScoresOf((field) => field.schema),
    score,
});
exports.MasterDataSchema = effect_1.Schema.Struct(recordFields);
exports.PartialMasterDataSchema = effect_1.Schema.Struct(optionalFields(recordFields));
exports.PartialMasterDataDatabaseSchema = effect_1.Schema.Struct(optionalFields(databaseFields)).pipe(effect_1.Schema.encodeKeys(databaseKeys));
//# sourceMappingURL=effect.js.map